(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["affiliate-choose"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const initPagination = (root) => {
      const sections = root.matches?.('.affiliate-choose') ? [root] : root.querySelectorAll('.affiliate-choose');

      for (const section of sections) {
        const track = section.querySelector('[data-affiliate-choose-track]');
        const dots = section.querySelectorAll('[data-affiliate-choose-dot]');

        if (!track || dots.length < 2 || track.dataset.paginationReady === 'true') continue;

        track.dataset.paginationReady = 'true';
        let frameId = null;

        const updatePagination = () => {
          const cards = track.querySelectorAll('[data-affiliate-choose-card]');
          const secondPage = cards[3];
          if (!secondPage) return;

          const pageIndex = Math.abs(track.scrollLeft - secondPage.offsetLeft) < Math.abs(track.scrollLeft) ? 1 : 0;

          for (const [index, dot] of dots.entries()) {
            dot.dataset.active = index === pageIndex ? 'true' : 'false';
          }
        };

        track.addEventListener('scroll', () => {
          if (frameId !== null) cancelAnimationFrame(frameId);
          frameId = requestAnimationFrame(updatePagination);
        }, { passive: true });

        updatePagination();
      }
    };

    initPagination(document);
    document.addEventListener('shopify:section:load', (event) => initPagination(event.target));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["affiliate-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const initializeAffiliateFaq = (root) => {
      const sections = root.matches?.('.affiliate-faq') ? [root] : root.querySelectorAll('.affiliate-faq');

      for (const section of sections) {
        const items = section.querySelectorAll('.affiliate-faq__item');

        for (const item of items) {
          if (item.dataset.affiliateFaqReady === 'true') continue;

          const summary = item.querySelector('.affiliate-faq__summary');
          const answer = item.querySelector('[data-affiliate-faq-answer]');
          if (!summary || !answer) continue;

          item.dataset.affiliateFaqReady = 'true';
          item.dataset.expanded = 'false';
          item.removeAttribute('open');

          const measureAnswer = () => {
            const wasOpen = item.open;
            answer.style.transition = 'none';

            if (!wasOpen) item.open = true;

            answer.style.position = 'absolute';
            answer.style.visibility = 'hidden';
            answer.style.pointerEvents = 'none';
            answer.style.width = `${summary.clientWidth}px`;
            answer.style.height = 'auto';

            const height = answer.scrollHeight;
            answer.dataset.expandedHeight = String(height);

            if (!wasOpen) item.open = false;

            answer.style.removeProperty('position');
            answer.style.removeProperty('visibility');
            answer.style.removeProperty('pointer-events');
            answer.style.removeProperty('width');
            answer.style.height = wasOpen ? 'auto' : '0px';
            answer.style.marginBlockStart = wasOpen ? '12px' : '0px';
            answer.style.opacity = wasOpen ? '1' : '0';
            answer.style.removeProperty('transition');

            return height;
          };

          const setImmediateState = (expanded) => {
            item.open = expanded;
            item.dataset.expanded = String(expanded);
            answer.style.height = expanded ? 'auto' : '0px';
            answer.style.marginBlockStart = expanded ? '12px' : '0px';
            answer.style.opacity = expanded ? '1' : '0';
          };

          const animateAnswer = (expanded) => {
            if (item.dataset.animating === 'true') return;

            if (reducedMotion.matches) {
              setImmediateState(expanded);
              return;
            }

            item.dataset.animating = 'true';
            item.dataset.expanded = String(expanded);
            answer.style.willChange = 'height, opacity';

            let finished = false;
            let timeoutId;

            const finish = () => {
              if (finished) return;
              finished = true;
              window.clearTimeout(timeoutId);
              answer.removeEventListener('transitionend', handleTransitionEnd);
              answer.style.removeProperty('will-change');
              answer.style.height = expanded ? 'auto' : '0px';
              if (!expanded) item.open = false;
              delete item.dataset.animating;
            };

            const handleTransitionEnd = (event) => {
              if (event.target === answer && event.propertyName === 'height') finish();
            };

            answer.addEventListener('transitionend', handleTransitionEnd);
            timeoutId = window.setTimeout(finish, 360);

            if (expanded) {
              item.open = true;
              answer.style.height = '0px';
              answer.style.marginBlockStart = '0px';
              answer.style.opacity = '0';

              const initializedHeight = Number(answer.dataset.expandedHeight);
              const height = answer.scrollHeight || initializedHeight;
              answer.dataset.expandedHeight = String(height);
              answer.getBoundingClientRect();

              window.requestAnimationFrame(() => {
                answer.style.height = `${height}px`;
                answer.style.marginBlockStart = '12px';
                answer.style.opacity = '1';
              });
              return;
            }

            const height = answer.scrollHeight;
            answer.dataset.expandedHeight = String(height);
            answer.style.height = `${height}px`;
            answer.style.marginBlockStart = '12px';
            answer.style.opacity = '1';
            answer.getBoundingClientRect();

            window.requestAnimationFrame(() => {
              answer.style.height = '0px';
              answer.style.marginBlockStart = '0px';
              answer.style.opacity = '0';
            });
          };

          measureAnswer();
          document.fonts?.ready.then(() => {
            if (!item.open && item.dataset.animating !== 'true') measureAnswer();
          });

          summary.addEventListener('click', (event) => {
            event.preventDefault();
            animateAnswer(!item.open);
          });
        }
      }
    };

    initializeAffiliateFaq(document);
    document.addEventListener('shopify:section:load', (event) => initializeAffiliateFaq(event.target));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autofull-accordion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class AutofullAccordion extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.animations = new Map();
        this.items = [...this.querySelectorAll('.autofull-accordion__item')];
        this.dataset.enhanced = '';
        const { signal } = this.controller;

        for (const item of this.items) {
          const trigger = item.querySelector('summary');
          item.dataset.expanded = String(item.open);
          trigger.setAttribute('aria-expanded', String(item.open));
          trigger.setAttribute('aria-disabled', String(item.open));
          item.querySelector('.autofull-accordion__panel').inert = !item.open;
          trigger.addEventListener('click', (event) => {
            event.preventDefault();
            if (item.dataset.expanded === 'true') return;
            this.setExpanded(item, true);
          }, { signal });
        }

        this.addEventListener('shopify:block:select', (event) => {
          const item = this.items.find((candidate) => candidate.dataset.blockId === event.detail.blockId);
          if (item) this.setExpanded(item, true, false);
        }, { signal });

        // Settle pending height animations before a desktop/mobile layout change.
        window.addEventListener('resize', () => this.finishAnimations(), { signal, passive: true });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.finishAnimations();
      }

      /** @param {HTMLDetailsElement} item @param {boolean} expanded @param {boolean} animate */
      setExpanded(item, expanded, animate = true) {
        if (expanded) {
          for (const other of this.items) {
            if (other !== item && other.dataset.expanded === 'true') this.setExpanded(other, false, animate);
          }
        }

        const panel = item.querySelector('.autofull-accordion__panel');
        const startHeight = item.open ? panel.getBoundingClientRect().height : 0;
        this.animations.get(item)?.cancel();
        this.animations.delete(item);
        item.dataset.expanded = String(expanded);
        item.querySelector('summary').setAttribute('aria-expanded', String(expanded));
        item.querySelector('summary').setAttribute('aria-disabled', String(expanded));
        if (!expanded && panel.contains(document.activeElement)) item.querySelector('summary').focus();
        panel.inert = !expanded;
        item.open = true;

        if (!animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          item.open = expanded;
          return;
        }

        const endHeight = expanded ? panel.firstElementChild.getBoundingClientRect().height : 0;
        const animation = panel.animate([
          { height: `${startHeight}px` },
          { height: `${endHeight}px` }
        ], { duration: 300, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'both' });

        this.animations.set(item, animation);
        animation.onfinish = () => {
          item.open = expanded;
          this.animations.delete(item);
          animation.cancel();
        };
      }

      finishAnimations() {
        if (!this.animations) return;
        for (const [item, animation] of this.animations) {
          item.open = item.dataset.expanded === 'true';
          animation.cancel();
        }
        this.animations.clear();
      }
    }

    const initialize = () => {
      if (!customElements.get('autofull-accordion')) customElements.define('autofull-accordion', AutofullAccordion);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autofull-compare"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const register = () => {
      if (customElements.get('autofull-compare-videos')) return;

      customElements.define('autofull-compare-videos', class extends HTMLElement {
        connectedCallback() {
          this.videos = [...this.querySelectorAll('video')];
          if (!this.videos.length) return;

          this.controller = new AbortController();
          this.activeIndex = 0;

          for (const video of this.videos) {
            video.muted = true;
            video.loop = this.videos.length === 1;
            video.pause();
            video.currentTime = 0;
            video.addEventListener('ended', () => {
              if (video !== this.videos[this.activeIndex]) return;

              video.pause();
              this.activeIndex = (this.activeIndex + 1) % this.videos.length;
              this.videos[this.activeIndex].currentTime = 0;
              this.#playVideo();
            }, { signal: this.controller.signal });
          }

          this.#playVideo();
        }

        async #playVideo() {
          try {
            await this.videos[this.activeIndex].play();
          } catch {}
        }

        disconnectedCallback() {
          this.controller?.abort();
          for (const video of this.videos || []) video.pause();
        }
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', register, { once: true });
    else register();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autofull-get-started"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const register = () => {
      if (customElements.get('autofull-get-started')) return;

      customElements.define('autofull-get-started', class extends HTMLElement {
        connectedCallback() {
          this.controller?.abort();
          this.controller = new AbortController();
          const { signal } = this.controller;
          this.tabs = [...this.querySelectorAll('[data-tab]')];
          this.panels = [...this.querySelectorAll('[data-panel]')];
          this.breakpoint = window.matchMedia('(max-width: 1149px)');

          this.tabs.forEach((tab) => {
            const panel = this.panels.find((item) => item.dataset.panel === tab.dataset.tab);
            if (panel) {
              panel.setAttribute('role', 'tabpanel');
              panel.setAttribute('aria-labelledby', tab.id);
              panel.removeAttribute('aria-label');
              panel.tabIndex = 0;
            }
          });
          this.activate(this.panels[0]?.dataset.panel);
          const navigation = this.querySelector('[data-tab-navigation]');
          if (navigation) navigation.hidden = false;

          this.querySelectorAll('[data-play]').forEach((button) => {
            const media = button.closest('[data-media-viewport]');
            const video = media.querySelector('video');
            video.setAttribute('aria-label', button.getAttribute('aria-label'));
            media.classList.add('autofull-get-started__media--ready');
            button.hidden = false;
          });

          this.addEventListener('click', (event) => {
            const tab = event.target.closest('[data-tab]');
            if (tab && this.contains(tab)) this.activate(tab.dataset.tab);
            const button = event.target.closest('[data-play]');
            if (button && this.contains(button)) this.play(button);
          }, { signal });

          this.addEventListener('keydown', (event) => {
            const tab = event.target.closest('[data-tab]');
            if (!tab || !this.tabs.includes(tab)) return;
            let index = this.tabs.indexOf(tab);
            const rtl = getComputedStyle(this).direction === 'rtl';
            if (event.key === 'ArrowRight') index += rtl ? -1 : 1;
            else if (event.key === 'ArrowLeft') index += rtl ? 1 : -1;
            else if (event.key === 'Home') index = 0;
            else if (event.key === 'End') index = this.tabs.length - 1;
            else return;
            event.preventDefault();
            const next = this.tabs[(index + this.tabs.length) % this.tabs.length];
            this.activate(next.dataset.tab);
            next.focus({ preventScroll: true });
            next.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }, { signal });

          this.breakpoint.addEventListener('change', () => this.pauseVideos(), { signal });
          document.addEventListener('visibilitychange', () => {
            if (document.hidden) this.pauseVideos();
          }, { signal });
          document.addEventListener('shopify:block:select', (event) => {
            if (this.panels.some((panel) => panel.dataset.panel === event.detail?.blockId)) {
              this.activate(event.detail.blockId);
            }
          }, { signal });
        }

        activate(id) {
          if (!id) return;
          this.panels.forEach((panel) => {
            panel.hidden = panel.dataset.panel !== id;
            if (panel.hidden) this.pauseVideos(panel);
          });
          this.tabs.forEach((tab) => {
            const selected = tab.dataset.tab === id;
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
          });
        }

        play(button) {
          const media = button.closest('[data-media-viewport]');
          const video = media.querySelector('video');
          media.classList.add('autofull-get-started__media--started');
          button.hidden = true;
          video.focus({ preventScroll: true });
          const playback = video.play();
          playback?.catch(() => {
            if (!this.isConnected) return;
            media.classList.remove('autofull-get-started__media--started');
            button.hidden = false;
            if (!media.closest('[data-panel]').hidden) button.focus({ preventScroll: true });
          });
        }

        pauseVideos(root = this) {
          root.querySelectorAll('video').forEach((video) => video.pause());
        }

        disconnectedCallback() {
          this.pauseVideos();
          this.controller?.abort();
        }
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', register, { once: true });
    else register();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autofull-kol-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initAutofullKolSlider = (sectionEl) => {
      if (!sectionEl || sectionEl.dataset.autofullKolInitialized === 'true') return;
      sectionEl.dataset.autofullKolInitialized = 'true';

      const swiperEl = sectionEl.querySelector('[data-kol-swiper]');
      let swiperInstance = null;
      if (swiperEl && typeof Swiper !== 'undefined') {
        swiperInstance = new Swiper(swiperEl, {
          slidesPerView: 'auto',
          spaceBetween: 12,
          watchOverflow: true,
          slideToClickedSlide: false,
          navigation: {
            nextEl: sectionEl.querySelector('[data-next]'),
            prevEl: sectionEl.querySelector('[data-prev]'),
          },
        });
      }

      const getVisibleVideo = (mediaEl) => {
        const mobileVideo = mediaEl.querySelector('.autofull-kol-slider__video--mobile');
        const desktopVideo = mediaEl.querySelector('.autofull-kol-slider__video--desktop');
        const isMobile = window.matchMedia('(max-width: 768px)').matches;
        return (isMobile && mobileVideo) || desktopVideo || mobileVideo;
      };

      const modalEl = sectionEl.querySelector('[data-video-modal]');
      const modalDialogEl = modalEl?.querySelector('[data-video-modal-dialog]');
      const modalPlayerEl = modalEl?.querySelector('[data-video-modal-player]');
      const modalCloseEl = modalEl?.querySelector('[data-video-modal-close]');
      let modalTriggerEl = null;
      let modalIsOpen = false;
      let modalSwiperState = null;

      const captureSwiperState = () => {
        if (!swiperInstance || swiperInstance.destroyed) return null;

        return {
          activeIndex: swiperInstance.activeIndex,
          translate: swiperInstance.translate,
          wrapperTransform: swiperInstance.wrapperEl?.style.transform || '',
          scrollLeft: swiperInstance.wrapperEl?.scrollLeft || 0,
        };
      };

      const restoreSwiperState = (state) => {
        if (!state || !swiperInstance || swiperInstance.destroyed) return;

        swiperInstance.setTransition(0);
        swiperInstance.setTranslate(state.translate);
        swiperInstance.updateProgress(state.translate);
        swiperInstance.updateActiveIndex(state.activeIndex);
        swiperInstance.updateSlidesClasses();

        if (swiperInstance.wrapperEl) {
          swiperInstance.wrapperEl.style.transform = state.wrapperTransform;
          swiperInstance.wrapperEl.scrollLeft = state.scrollLeft;
        }
      };

      const focusableSelector =
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), video[controls], [tabindex]:not([tabindex="-1"])';

      const getModalFocusableElements = () => {
        if (!modalEl) return [];
        return [...modalEl.querySelectorAll(focusableSelector)].filter((element) => !element.hidden);
      };

      const clearModalVideo = () => {
        const videoEl = modalPlayerEl?.querySelector('video');
        if (videoEl) videoEl.pause();
        modalPlayerEl?.replaceChildren();
      };

      const closeModal = () => {
        if (!modalEl || !modalIsOpen) return;

        modalIsOpen = false;
        modalEl.classList.remove('is-open');
        modalEl.setAttribute('aria-hidden', 'true');
        modalEl.hidden = true;
        document.documentElement.classList.remove('autofull-kol-slider-modal-open');
        clearModalVideo();

        const triggerEl = modalTriggerEl;
        const swiperState = modalSwiperState;
        modalTriggerEl = null;
        modalSwiperState = null;
        triggerEl?.focus({ preventScroll: true });

        requestAnimationFrame(() => {
          restoreSwiperState(swiperState);
          requestAnimationFrame(() => restoreSwiperState(swiperState));
        });
      };

      const openModal = (triggerEl) => {
        if (!modalEl || !modalPlayerEl || !modalCloseEl) return;

        const mediaEl = triggerEl.closest('.autofull-kol-slider__card')?.querySelector('[data-video-media]');
        if (!mediaEl) return;

        const previewVideoEl = getVisibleVideo(mediaEl);
        if (!previewVideoEl) return;

        clearModalVideo();
        modalSwiperState = modalSwiperState || captureSwiperState();

        const videoEl = previewVideoEl.cloneNode(true);
        videoEl.className = 'autofull-kol-slider__modal-video tw:h-full tw:w-full tw:object-contain';
        videoEl.controls = true;
        videoEl.loop = false;
        videoEl.muted = false;
        videoEl.autoplay = false;
        videoEl.preload = 'metadata';
        videoEl.removeAttribute('aria-hidden');
        modalPlayerEl.append(videoEl);

        modalTriggerEl = triggerEl;
        modalIsOpen = true;
        modalEl.hidden = false;
        modalEl.setAttribute('aria-hidden', 'false');
        modalEl.classList.add('is-open');
        document.documentElement.classList.add('autofull-kol-slider-modal-open');
        modalCloseEl.focus({ preventScroll: true });

        const playPromise = videoEl.play();
        if (playPromise?.catch) playPromise.catch(() => {});
      };

      sectionEl.addEventListener(
        'click',
        (event) => {
          const cardEl = event.target instanceof Element ? event.target.closest('[data-video-card]') : null;
          if (!cardEl) return;

          // Keep Swiper's click handler from treating the modal trigger as a slide click.
          event.stopPropagation();
          restoreSwiperState(modalSwiperState);
          openModal(cardEl);
        },
        true
      );

      sectionEl.addEventListener(
        'pointerdown',
        (event) => {
          const cardEl = event.target instanceof Element ? event.target.closest('[data-video-card]') : null;
          if (cardEl) modalSwiperState = captureSwiperState();
        },
        true
      );

      sectionEl.querySelectorAll('[data-video-card]').forEach((cardEl) => {
        cardEl.addEventListener('mousedown', (event) => {
          // Prevent mouse focus from scrolling the transformed Swiper slide into view.
          if (event.button === 0) event.preventDefault();
        });
      });

      modalCloseEl?.addEventListener('click', closeModal);
      modalEl?.addEventListener('keydown', (event) => {
        if (!modalIsOpen) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          closeModal();
          return;
        }

        if (event.key !== 'Tab') return;

        const focusableElements = getModalFocusableElements();
        if (focusableElements.length === 0) {
          event.preventDefault();
          modalEl.focus({ preventScroll: true });
          return;
        }

        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstFocusable) {
          event.preventDefault();
          lastFocusable.focus({ preventScroll: true });
        } else if (!event.shiftKey && document.activeElement === lastFocusable) {
          event.preventDefault();
          firstFocusable.focus({ preventScroll: true });
        }
      });
      modalEl?.addEventListener('click', (event) => {
        if (event.target === modalEl || !modalDialogEl?.contains(event.target)) closeModal();
      });
    };

    const initAll = () => {
      document.querySelectorAll('[data-autofull-kol-slider]').forEach(initAutofullKolSlider);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAutofullKolSlider(event.target.querySelector('[data-autofull-kol-slider]') || event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const sectionEl = event.target.matches('[data-autofull-kol-slider]')
        ? event.target
        : event.target.querySelector('[data-autofull-kol-slider]');
      const modalEl = sectionEl?.querySelector('[data-video-modal]');
      if (modalEl && !modalEl.hidden) modalEl.hidden = true;
      document.documentElement.classList.remove('autofull-kol-slider-modal-open');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autofull-ksp"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('autofull-ksp')) {
    class AutofullKsp extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true, signal: this.controller.signal });
        } else {
          this.initialize();
        }
      }

      initialize() {
        const { signal } = this.controller;
        this.desktop = window.matchMedia('(min-width: 1150px)');
        this.hover = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.details = [...this.querySelectorAll('[data-ksp-details]')];
        this.transitions = new Map();
        this.duration = Number(this.dataset.duration) || 0;
        this.initializeVideos(signal);

        for (const details of this.details) {
          const card = details.closest('.autofull-ksp__card');
          const summary = details.querySelector('summary');
          if (!details.querySelector('.autofull-ksp__description')) {
            summary.addEventListener('click', (event) => event.preventDefault(), { signal });
            continue;
          }
          card.addEventListener('pointerenter', () => {
            if (this.desktop.matches && this.hover.matches) this.setDetailsOpen(details, true);
          }, { signal });
          card.addEventListener('pointerleave', () => {
            if (this.desktop.matches && this.hover.matches && !details.contains(document.activeElement)) this.setDetailsOpen(details, false);
          }, { signal });
          summary.addEventListener('click', (event) => {
            event.preventDefault();
            const expanded = this.transitions.get(details)?.expanded ?? details.open;
            this.setDetailsOpen(details, !expanded);
          }, { signal });
          card.addEventListener('click', (event) => {
            if (this.desktop.matches || event.defaultPrevented) return;
            const expanded = this.transitions.get(details)?.expanded ?? details.open;
            this.setDetailsOpen(details, !expanded);
          }, { signal });
          details.addEventListener('focusout', (event) => {
            if (this.desktop.matches && !details.contains(event.relatedTarget)) this.setDetailsOpen(details, false);
          }, { signal });
          details.addEventListener('keydown', (event) => {
            if (event.key !== 'Escape') return;
            this.setDetailsOpen(details, false);
            details.querySelector('summary').focus({ preventScroll: true });
          }, { signal });
        }

        this.desktop.addEventListener('change', () => {
          for (const details of this.details) this.setDetailsOpen(details, false, false);
        }, { signal });
        this.reducedMotion.addEventListener('change', () => {
          for (const [details, state] of this.transitions) this.setDetailsOpen(details, state.expanded, false);
        }, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          const details = event.target.closest('.autofull-ksp__card')?.querySelector('[data-ksp-details]');
          if (details) this.setDetailsOpen(details, true, false);
        }, { signal });
      }

      initializeVideos(signal) {
        this.videos = [...this.querySelectorAll('.autofull-ksp__video')];
        this.videoVisible = false;
        if (!this.videos.length) return;
        for (const video of this.videos) {
          video.muted = true;
        }
        this.videoObserver = new IntersectionObserver((entries) => {
          this.videoVisible = entries[0].isIntersecting;
          this.updateVideos();
        }, { threshold: 0 });
        this.videoObserver.observe(this.closest('section'));
        document.addEventListener('visibilitychange', () => this.updateVideos(), { signal });
      }

      updateVideos() {
        for (const video of this.videos) {
          if (!this.videoVisible || document.hidden) {
            video.pause();
            continue;
          }
          const playback = video.play();
          if (playback) playback.catch(() => {});
        }
      }

      /** Expand the bottom caption upward; retain its current height when reversing. */
      async setDetailsOpen(details, expanded, animate = true) {
        const previous = this.transitions.get(details);
        if (animate && (previous?.expanded ?? details.open) === expanded) return;
        if (expanded && !this.desktop.matches) {
          for (const other of this.details) {
            if (other !== details && (this.transitions.get(other)?.expanded ?? other.open)) this.setDetailsOpen(other, false, animate);
          }
        }
        const description = details.querySelector('.autofull-ksp__description');
        const chevron = details.querySelector('.autofull-ksp__card-chevron');
        if (!description || !chevron) {
          details.open = expanded;
          return;
        }
        const startRotation = getComputedStyle(chevron).transform;
        const currentStyle = getComputedStyle(details);
        const startHeight = details.getBoundingClientRect().height;
        const startBackground = currentStyle.backgroundColor;
        const descriptionOpacity = previous ? getComputedStyle(description).opacity : expanded ? 0 : 1;
        previous?.animation.cancel();
        previous?.contentAnimation.cancel();
        previous?.indicatorAnimation.cancel();
        this.transitions.delete(details);

        if (!animate || this.reducedMotion.matches || this.duration === 0) {
          details.open = expanded;
          if (!expanded) details.scrollTop = description.scrollTop = 0;
          return;
        }

        details.open = false;
        const collapsedHeight = details.getBoundingClientRect().height;
        details.open = true;
        const endHeight = expanded ? details.getBoundingClientRect().height : collapsedHeight;
        const animation = details.animate(
          [
            { height: `${startHeight}px`, insetBlockStart: 'auto', overflow: 'hidden', backgroundColor: startBackground },
            {
              height: `${endHeight}px`, insetBlockStart: 'auto', overflow: 'hidden',
              backgroundColor: currentStyle.getPropertyValue(expanded ? '--ksp-overlay-background' : '--ksp-caption-background').trim()
            }
          ],
          { duration: this.duration, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'both' }
        );
        const contentAnimation = description.animate(
          [{ opacity: descriptionOpacity }, { opacity: expanded ? 1 : 0 }],
          { duration: this.duration, easing: 'ease-in-out', fill: 'both' }
        );
        const indicatorAnimation = chevron.animate(
          [{ transform: startRotation }, { transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)' }],
          { duration: this.duration, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'both' }
        );
        const state = { expanded, animation, contentAnimation, indicatorAnimation };
        this.transitions.set(details, state);
        try {
          await animation.finished;
        } catch {
          return;
        }
        if (this.transitions.get(details) !== state) return;
        details.open = expanded;
        animation.cancel();
        contentAnimation.cancel();
        indicatorAnimation.cancel();
        if (!expanded) details.scrollTop = description.scrollTop = 0;
        this.transitions.delete(details);
      }

      disconnectedCallback() {
        this.controller.abort();
        this.videoObserver?.disconnect();
        for (const video of this.videos || []) video.pause();
        for (const state of this.transitions?.values() || []) {
          state.animation.cancel();
          state.contentAnimation.cancel();
          state.indicatorAnimation.cancel();
        }
        this.transitions?.clear();
      }
    }

    customElements.define('autofull-ksp', AutofullKsp);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autofull-media"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const register = () => {
      if (customElements.get('autofull-media-video')) return;

      customElements.define('autofull-media-video', class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          if (!this.video) return;

          this.visible = false;
          this.video.muted = true;
          this.controller = new AbortController();
          document.addEventListener('visibilitychange', () => this.updatePlayback(), { signal: this.controller.signal });
          this.observer = new IntersectionObserver((entries) => {
            this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.1;
            this.updatePlayback();
          }, { threshold: 0.1 });
          this.observer.observe(this.video);
        }

        updatePlayback() {
          if (!this.visible || document.hidden) {
            this.video.pause();
            return;
          }

          const playback = this.video.play();
          if (playback) playback.catch(() => {});
        }

        disconnectedCallback() {
          this.visible = false;
          this.observer?.disconnect();
          this.controller?.abort();
          this.video?.pause();
        }
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', register, { once: true });
    else register();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autofull-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = () => {
      if (customElements.get('autofull-nav')) return;

      customElements.define(
        'autofull-nav',
        class extends HTMLElement {
          connectedCallback() {
            this.controller = new AbortController();
            this.wrapper = this.closest('.shopify-section') || this;
            this.menu = this.querySelector('.autofull-nav__menu');
            this.links = [...this.querySelectorAll('[data-nav-link]')];
            this.update = this.update.bind(this);
            this.schedule = this.schedule.bind(this);
            const options = { signal: this.controller.signal };

            this.addEventListener('click', (event) => this.onClick(event), options);
            this.addEventListener(
              'shopify:block:select',
              (event) => {
                const link = event.target.closest('[data-block-id]')?.querySelector('[data-nav-link]');
                if (link) this.revealLink(link);
              },
              options
            );
            this.menu?.addEventListener('scroll', () => this.updateOverflow(), { ...options, passive: true });
            window.addEventListener('scroll', this.schedule, { ...options, passive: true });
            window.addEventListener('resize', this.schedule, options);
            ['wheel', 'touchstart', 'keydown'].forEach((type) => {
              window.addEventListener(type, () => this.cancelNavigation(), { ...options, passive: true });
            });
            window.addEventListener(
              'scrollend',
              (event) => {
                if (event.target === document) this.settleNavigation();
              },
              options
            );
            window.addEventListener('hashchange', () => this.followHash(), options);
            window.addEventListener('popstate', () => this.followHash(), options);
            document.addEventListener('shopify:section:load', this.schedule, options);
            document.addEventListener('shopify:section:unload', this.schedule, options);
            this.observer = new ResizeObserver(this.schedule);
            this.observer.observe(this);
            this.update();
            if (document.readyState === 'complete') this.followHash();
            else window.addEventListener('load', () => this.followHash(), { ...options, once: true });
          }

          disconnectedCallback() {
            this.controller.abort();
            this.observer.disconnect();
            cancelAnimationFrame(this.frame);
            this.cancelNavigation();
          }

          targetFor(link) {
            if (!link) return null;
            let targetId = link.dataset.targetId;
            if (!targetId) {
              const url = new URL(link.href, location.href);
              if (
                url.origin !== location.origin ||
                url.pathname !== location.pathname ||
                url.search !== location.search ||
                !url.hash
              )
                return null;
              try {
                targetId = decodeURIComponent(url.hash.slice(1));
              } catch {
                return null;
              }
            }
            if (!targetId) return null;
            return (
              document.getElementById(targetId) ||
              document.getElementById(`shopify-section-${targetId}`) ||
              document.querySelector(
                `[data-anchor-id="${CSS.escape(targetId)}"], [data-section-id="${CSS.escape(targetId)}"]`
              )
            );
          }

          offset() {
            const style = getComputedStyle(this.wrapper);
            const isSticky = style.position === 'sticky';
            const header = document.querySelector('.shopify-section--header');
            const headerBottom =
              header && getComputedStyle(header).visibility !== 'hidden'
                ? Math.max(0, header.getBoundingClientRect().bottom)
                : 0;
            const top = isSticky ? parseFloat(style.top) || 0 : headerBottom;
            return top + (isSticky ? this.offsetHeight : 0) + Number(this.dataset.scrollOffset || 0);
          }

          behavior() {
            return this.dataset.smoothScroll === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches
              ? 'smooth'
              : 'instant';
          }

          revealLink(link) {
            if (!this.menu || this.menu.scrollWidth <= this.menu.clientWidth) return;
            const item = link.getBoundingClientRect();
            const menu = this.menu.getBoundingClientRect();
            if (item.left >= menu.left + 16 && item.right <= menu.right - 28) return;
            this.menu.scrollTo({
              left: this.menu.scrollLeft + item.left - menu.left - (menu.width - item.width) / 2,
              behavior: this.behavior(),
            });
          }

          setActive(link) {
            if (this.activeLink === link) return;
            this.links.forEach((item) => {
              if (item === link) item.setAttribute('aria-current', 'location');
              else item.removeAttribute('aria-current');
            });
            this.activeLink = link;
            if (link) this.revealLink(link);
          }

          updateOverflow() {
            if (!this.menu) return;
            this.menu.dataset.overflow = String(this.menu.scrollWidth > this.menu.clientWidth + 1);
            this.menu.dataset.atEnd = String(this.menu.scrollLeft + this.menu.clientWidth >= this.menu.scrollWidth - 2);
          }

          update() {
            this.updateOverflow();
            if (this.dataset.scrollSpy !== 'true') return;
            if (this.pendingLink) {
              const target = this.targetFor(this.pendingLink);
              const desiredTop = target && Math.max(0, target.getBoundingClientRect().top + scrollY - this.offset());
              const maxTop = document.documentElement.scrollHeight - innerHeight;
              if (
                target &&
                performance.now() < this.scrollDeadline &&
                Math.abs(scrollY - Math.min(desiredTop, maxTop)) > 2
              )
                return;
              this.pendingLink = null;
            }
            const items = this.links
              .map((link) => ({ link, target: this.targetFor(link) }))
              .filter((item) => item.target && item.target.getClientRects().length)
              .map((item) => ({ ...item, top: item.target.getBoundingClientRect().top }))
              .sort((a, b) => a.top - b.top);
            if (!items.length) return;
            const passed = items.filter((item) => item.top <= this.offset() + 2);
            let active = passed.at(-1) || items[0];
            if (window.scrollY > 0 && window.scrollY + innerHeight >= document.documentElement.scrollHeight - 2)
              active = items.at(-1);
            this.setActive(active.link);
          }

          schedule() {
            if (this.frame) return;
            this.frame = requestAnimationFrame(() => {
              this.frame = 0;
              this.update();
            });
          }

          cancelNavigation() {
            clearTimeout(this.navigationTimer);
            this.pendingLink = null;
            this.pendingTarget = null;
          }

          settleNavigation() {
            const target = this.pendingTarget;
            this.cancelNavigation();
            if (!target?.isConnected) return;
            // The main header can appear or hide during a smooth scroll.
            const top = Math.max(0, target.getBoundingClientRect().top + scrollY - this.offset());
            if (Math.abs(scrollY - top) > 1) window.scrollTo({ top, behavior: 'instant' });
            this.schedule();
          }

          navigate(target, link, updateHistory = true, behavior = this.behavior()) {
            this.cancelNavigation();
            this.pendingTarget = target;
            this.navigationTimer = setTimeout(() => this.settleNavigation(), 1800);
            if (link?.matches('[data-nav-link]')) {
              this.setActive(link);
              this.pendingLink = behavior === 'smooth' ? link : null;
              this.scrollDeadline = performance.now() + 1800;
            }
            if (updateHistory && target.id) {
              const hash = `#${encodeURIComponent(target.id)}`;
              if (location.hash !== hash) history.pushState(null, '', hash);
            }
            window.scrollTo({
              top: Math.max(0, target.getBoundingClientRect().top + scrollY - this.offset()),
              behavior,
            });
          }

          onClick(event) {
            const link = event.target.closest('a');
            if (
              !link ||
              !this.contains(link) ||
              event.defaultPrevented ||
              event.button !== 0 ||
              event.metaKey ||
              event.ctrlKey ||
              event.shiftKey ||
              event.altKey ||
              link.target === '_blank' ||
              link.hasAttribute('download')
            )
              return;
            const target = this.targetFor(link);
            if (target) {
              event.preventDefault();
              this.navigate(target, link);
            } else if (link.getAttribute('href')?.startsWith('#')) {
              // A section may still be unset or absent in the theme editor.
              event.preventDefault();
            }
          }

          followHash() {
            const link = [...this.links, this.querySelector('[data-buy-link]')].find((item) => {
              const target = this.targetFor(item);
              return target?.id && `#${encodeURIComponent(target.id)}` === location.hash;
            });
            const target = this.targetFor(link);
            if (target) this.navigate(target, link, false, 'instant');
          }
        }
      );
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autofull-point"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function registerAutofullPoint() {
      if (customElements.get('autofull-point')) return;

      customElements.define('autofull-point', class extends HTMLElement {
        connectedCallback() {
          // A registered element can connect while its children are still
          // being parsed (or while the editor replaces a section).
          const connection = this.connection = (this.connection || 0) + 1;
          queueMicrotask(() => {
            if (this.isConnected && this.connection === connection) this.initialize();
          });
        }

        initialize() {
          this.controller?.abort();
          this.observer?.disconnect();
          this.controller = new AbortController();
          const options = { signal: this.controller.signal };
          this.items = [...this.querySelectorAll('.autofull-point__item')];
          this.closeTimers = new Map();
          this.activeItem = null;
          this.mobileQuery = matchMedia('(max-width: 1149px)');
          this.mobileQuery.addEventListener('change', () => {
            this.schedulePosition();
            if (this.activeItem) this.playVideo(this.activeItem);
          }, options);
          this.setAttribute('data-ready', '');

          this.items.forEach((item) => {
            item.open = false;
            item.dataset.expanded = 'false';
            const panel = item.querySelector('.autofull-point__panel');
            panel.inert = true;
            panel.setAttribute('aria-hidden', 'true');
            item.querySelector('summary').setAttribute('aria-expanded', 'false');
          });

          this.addEventListener('click', (event) => {
            const trigger = event.target.closest('.autofull-point__trigger');
            if (!trigger || !this.contains(trigger)) return;
            event.preventDefault();
            const item = trigger.closest('details');
            if (item.dataset.expanded === 'true') this.close(item);
            else this.open(item);
          }, options);

          document.addEventListener('pointerdown', (event) => {
            if (this.activeItem && !this.activeItem.contains(event.target)) this.close(this.activeItem);
          }, options);

          this.addEventListener('keydown', (event) => {
            if (event.key !== 'Escape' || !this.activeItem) return;
            event.preventDefault();
            this.close(this.activeItem, true);
          }, options);

          document.addEventListener('shopify:block:select', (event) => {
            const item = this.items.find((entry) => entry.dataset.pointId === event.detail.blockId);
            if (item) this.open(item);
          }, options);

          document.addEventListener('shopify:block:deselect', (event) => {
            if (this.activeItem?.dataset.pointId === event.detail.blockId) this.close(this.activeItem);
          }, options);

          this.observer = new ResizeObserver(() => this.schedulePosition());
          this.observer.observe(this);
          this.items.forEach((item) => this.observer.observe(item.querySelector('.autofull-point__panel')));
          const initial = Number(this.dataset.initialPoint) - 1;
          if (this.items[initial]) this.open(this.items[initial]);
        }

        disconnectedCallback() {
          for (const video of this.querySelectorAll('video')) video.pause();
          this.controller?.abort();
          this.observer?.disconnect();
          cancelAnimationFrame(this.positionFrame);
          this.closeTimers?.forEach((timer) => clearTimeout(timer));
        }

        open(item) {
          if (this.activeItem && this.activeItem !== item) this.close(this.activeItem);
          clearTimeout(this.closeTimers.get(item));
          this.closeTimers.delete(item);
          this.activeItem = item;
          item.open = true;
          const panel = item.querySelector('.autofull-point__panel');
          panel.inert = false;
          panel.setAttribute('aria-hidden', 'false');
          item.querySelector('summary').setAttribute('aria-expanded', 'true');
          this.position(item);
          // Commit the closed frame before starting the opening transition.
          panel.getBoundingClientRect();
          item.dataset.expanded = 'true';
          this.playVideo(item);
        }

        close(item, returnFocus = false) {
          if (this.activeItem === item) this.activeItem = null;
          for (const video of item.querySelectorAll('video')) video.pause();
          const panel = item.querySelector('.autofull-point__panel');
          if (returnFocus || panel.contains(document.activeElement)) item.querySelector('summary').focus({ preventScroll: true });
          item.dataset.expanded = 'false';
          item.querySelector('summary').setAttribute('aria-expanded', 'false');
          panel.inert = true;
          panel.setAttribute('aria-hidden', 'true');
          clearTimeout(this.closeTimers.get(item));
          const delay = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 260;
          this.closeTimers.set(item, setTimeout(() => {
            item.open = false;
            this.closeTimers.delete(item);
          }, delay));
        }

        playVideo(item) {
          const activeClass = this.mobileQuery.matches ? 'autofull-point__video--mobile' : 'autofull-point__video--desktop';
          for (const video of item.querySelectorAll('video')) {
            if (!video.classList.contains(activeClass)) {
              video.pause();
              continue;
            }
            if (!video.dataset.loaded) {
              for (const source of video.querySelectorAll('source[data-src]')) source.src = source.dataset.src;
              video.load();
              video.dataset.loaded = 'true';
            }
            if (!matchMedia('(prefers-reduced-motion: reduce)').matches) video.play().catch(() => {});
          }
        }

        schedulePosition() {
          cancelAnimationFrame(this.positionFrame);
          this.positionFrame = requestAnimationFrame(() => {
            if (this.activeItem) this.position(this.activeItem);
          });
        }

        position(item) {
          const panel = item.querySelector('.autofull-point__panel');
          const stage = this.getBoundingClientRect();
          if (!stage.width || !stage.height) return;
          const mobile = this.mobileQuery.matches;
          const point = item.getBoundingClientRect();
          const x = point.left - stage.left;
          const y = point.top - stage.top;
          const inset = Math.min(16, stage.width / 10);
          const corner = mobile ? 24 : 48;
          panel.style.setProperty('--af-point-panel-max-height', `${Math.max(1, stage.height - inset * 2)}px`);
          const width = panel.offsetWidth;
          const height = panel.offsetHeight;
          const anchor = mobile ? item.dataset.cardAnchorMobile : item.dataset.cardAnchor;
          const style = getComputedStyle(item);
          const suffix = mobile ? '-mobile' : '';
          const offsetX = parseFloat(style.getPropertyValue(`--af-point-offset-x${suffix}`)) || 0;
          const offsetY = parseFloat(style.getPropertyValue(`--af-point-offset-y${suffix}`)) || 0;
          // Each card follows its designed corner; only clamp at the canvas
          // edge so resizing or long copy never moves the point itself.
          let left = (anchor.endsWith('right') ? x + corner - width : x - corner) + offsetX;
          let top = (anchor.startsWith('bottom') ? y + corner - height : y - corner) + offsetY;
          left = Math.max(inset, Math.min(left, stage.width - width - inset));
          top = Math.max(inset, Math.min(top, stage.height - height - inset));
          panel.style.setProperty('--af-point-panel-left', `${left - x}px`);
          panel.style.setProperty('--af-point-panel-top', `${top - y}px`);
          panel.style.setProperty('--af-point-origin-x', `${x - left}px`);
          panel.style.setProperty('--af-point-origin-y', `${y - top}px`);
        }
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', registerAutofullPoint, { once: true });
    else registerAutofullPoint();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autofull-product-info"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class AutofullProductInfo extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.tabs = [...this.querySelectorAll('[data-info-tab]')];
        this.panels = [...this.querySelectorAll('[data-info-panel]')];
        const tabList = this.querySelector('[data-info-tabs]');
        if (tabList) {
          tabList.hidden = false;
          tabList.setAttribute('role', 'tablist');
          this.tabs.forEach((tab) => {
            tab.setAttribute('role', 'tab');
            tab.addEventListener('click', () => this.selectVersion(tab.dataset.infoTab), { signal });
            tab.addEventListener('keydown', (event) => {
              const index = this.tabs.indexOf(tab);
              let next;
              if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
              if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
              if (event.key === 'Home') next = 0;
              if (event.key === 'End') next = this.tabs.length - 1;
              if (next === undefined) return;
              event.preventDefault();
              this.selectVersion(this.tabs[next].dataset.infoTab);
              this.tabs[next].focus();
            }, { signal });
          });
        }
        const visible = Math.max(0, Number(this.dataset.visibleGroups) || 0);
        this.panels.forEach((panel) => {
          if (tabList) {
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('aria-labelledby', this.tabs.find((tab) => tab.dataset.infoTab === panel.dataset.infoPanel).id);
            panel.tabIndex = 0;
          }
          const groups = [...panel.querySelectorAll('[data-info-group]')];
          const toggle = panel.querySelector('[data-info-toggle]');
          panel.infoExtraGroups = groups.slice(visible);
          if (panel.infoExtraGroups.length) {
            toggle.hidden = false;
            this.setExpanded(panel, false);
            toggle.addEventListener('click', () => this.setExpanded(panel, toggle.getAttribute('aria-expanded') !== 'true'), { signal });
          }
        });
        this.selectVersion(this.tabs[0]?.dataset.infoTab || 'standard');

        this.dialog = this.querySelector('[data-info-dialog]');
        this.addEventListener('click', (event) => {
          const link = event.target.closest('[data-info-zoom]');
          if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.zoomTrigger = link;
          const image = new Image();
          image.src = link.href;
          image.alt = link.dataset.imageAlt;
          image.width = Number(link.dataset.imageWidth);
          image.height = Number(link.dataset.imageHeight);
          this.querySelector('[data-info-zoom-content]').replaceChildren(image);
          this.dialog.showModal();
        }, { signal });
        this.querySelector('[data-info-close]').addEventListener('click', () => this.dialog.close(), { signal });
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, { signal });
        this.dialog.addEventListener('close', () => {
          this.querySelector('[data-info-zoom-content]').replaceChildren();
          this.zoomTrigger?.focus();
        }, { signal });
        document.addEventListener('shopify:block:select', (event) => {
          const group = event.target.closest('[data-info-group]');
          if (!group || !this.contains(group)) return;
          const panel = group.closest('[data-info-panel]');
          this.selectVersion(panel.dataset.infoPanel);
          this.setExpanded(panel, true);
        }, { signal });
      }
      disconnectedCallback() {
        this.dialog?.close();
        this.controller?.abort();
      }
      selectVersion(version) {
        this.tabs.forEach((tab) => {
          const active = tab.dataset.infoTab === version;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.infoPanel !== version;
          if (panel.hidden) panel.querySelectorAll('video').forEach((video) => video.pause());
        });
      }
      setExpanded(panel, expanded) {
        panel.infoExtraGroups.forEach((group) => { group.hidden = !expanded; });
        const toggle = panel.querySelector('[data-info-toggle]');
        toggle.hidden = !panel.infoExtraGroups.length || expanded && this.dataset.showCollapse !== 'true';
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.querySelector('[data-info-toggle-label]').textContent = expanded ? toggle.dataset.less : toggle.dataset.more;
      }
    }
    const initialize = () => {
      if (!customElements.get('autofull-product-info')) customElements.define('autofull-product-info', AutofullProductInfo);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autofull-review-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const initAutofullReviewSlider = (sectionEl) => {
      if (!sectionEl || sectionEl.dataset.autofullReviewInitialized === 'true') return;
      sectionEl.dataset.autofullReviewInitialized = 'true';

      const dialogEl = sectionEl.querySelector('[data-review-dialog]');
      const panels = [...sectionEl.querySelectorAll('[data-review-panel]')];
      const galleryInstances = new Map();
      let returnFocusEl = null;
      let documentOverflow = '';
      let documentScrollbarGutter = '';
      let closeTimer = null;

      const reviewSwiper = new Swiper(sectionEl.querySelector('[data-review-swiper]'), {
        slidesPerView: 'auto',
        spaceBetween: 12,
        watchOverflow: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        navigation: {
          nextEl: sectionEl.querySelector('[data-review-next]'),
          prevEl: sectionEl.querySelector('[data-review-prev]'),
        },
        a11y: {
          enabled: true,
        },
      });

      const initGallery = (panelEl) => {
        if (galleryInstances.has(panelEl)) return galleryInstances.get(panelEl);

        const thumbsSwiper = new Swiper(panelEl.querySelector('[data-modal-thumbs]'), {
          slidesPerView: 'auto',
          spaceBetween: 8,
          centerInsufficientSlides: true,
          watchOverflow: true,
          watchSlidesProgress: true,
          freeMode: true,
        });

        const modalSwiper = new Swiper(panelEl.querySelector('[data-modal-swiper]'), {
          slidesPerView: 1,
          spaceBetween: 0,
          watchOverflow: true,
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          navigation: {
            nextEl: panelEl.querySelector('[data-modal-next]'),
            prevEl: panelEl.querySelector('[data-modal-prev]'),
          },
          thumbs: {
            swiper: thumbsSwiper,
          },
          a11y: {
            enabled: true,
          },
        });

        const instances = { modalSwiper, thumbsSwiper };
        galleryInstances.set(panelEl, instances);
        return instances;
      };

      const openDialog = (index, triggerEl) => {
        if (!dialogEl || !panels[index]) return;

        for (const panelEl of panels) panelEl.hidden = true;
        const activePanel = panels[index];
        activePanel.hidden = false;
        returnFocusEl = triggerEl;
        documentOverflow = document.documentElement.style.overflow;
        documentScrollbarGutter = document.documentElement.style.scrollbarGutter;
        document.documentElement.style.scrollbarGutter = 'stable';
        document.documentElement.style.overflow = 'hidden';
        dialogEl.classList.remove('is-closing');
        dialogEl.showModal();

        requestAnimationFrame(() => {
          const instances = initGallery(activePanel);
          instances.thumbsSwiper.update();
          instances.modalSwiper.update();
          instances.modalSwiper.slideTo(0, 0);
          sectionEl.querySelector('[data-review-close]')?.focus();
        });
      };

      const closeDialog = () => {
        if (!dialogEl?.open || dialogEl.classList.contains('is-closing')) return;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          dialogEl.close();
          return;
        }

        dialogEl.classList.add('is-closing');
        closeTimer = window.setTimeout(() => {
          dialogEl.close();
        }, 180);
      };

      sectionEl.querySelectorAll('[data-review-card]').forEach((cardEl) => {
        cardEl.addEventListener('click', () => {
          openDialog(Number(cardEl.dataset.reviewCard), cardEl);
        });
      });

      sectionEl.querySelector('[data-review-close]')?.addEventListener('click', closeDialog);
      dialogEl?.addEventListener('click', (event) => {
        if (event.target === dialogEl) closeDialog();
      });
      dialogEl?.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeDialog();
      });
      dialogEl?.addEventListener('close', () => {
        if (closeTimer) window.clearTimeout(closeTimer);
        closeTimer = null;
        dialogEl.classList.remove('is-closing');
        document.documentElement.style.overflow = documentOverflow;
        document.documentElement.style.scrollbarGutter = documentScrollbarGutter;
        returnFocusEl?.focus();
        returnFocusEl = null;
      });

      sectionEl.autofullReviewCleanup = () => {
        if (closeTimer) window.clearTimeout(closeTimer);
        if (dialogEl?.open) dialogEl.close();
        reviewSwiper.destroy(true, true);
        for (const instances of galleryInstances.values()) {
          instances.modalSwiper.destroy(true, true);
          instances.thumbsSwiper.destroy(true, true);
        }
      };
    };

    const initAll = () => {
      document.querySelectorAll('[data-autofull-review-slider]').forEach(initAutofullReviewSlider);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => {
      initAutofullReviewSlider(event.target.querySelector('[data-autofull-review-slider]') || event.target);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      const sectionEl = event.target.querySelector('[data-autofull-review-slider]') || event.target;
      sectionEl.autofullReviewCleanup?.();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autofull-scene-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const register = () => {
      if (customElements.get('autofull-scene-slider')) return;

      customElements.define('autofull-scene-slider', class extends HTMLElement {
        connectedCallback() {
          this.frame = requestAnimationFrame(() => this.initialize());
        }

        initialize() {
          this.viewport = this.querySelector('[data-scene-viewport]');
          if (!this.viewport || this.swiper) return;

          this.controller = new AbortController();
          const { signal } = this.controller;
          this.slides = [...this.querySelectorAll('[data-scene-slide]')];
          this.captions = [...this.querySelectorAll('[data-scene-caption]')];
          this.buttons = [...this.querySelectorAll('[data-scene-action]')];
          this.videos = [...this.querySelectorAll('video')];
          this.status = this.querySelector('[data-scene-status]');
          this.mobile = matchMedia('(max-width: 768px)');
          this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
          const styles = getComputedStyle(this);
          const loop = this.dataset.loop === 'true' && this.captions.length > 1;

          this.swiper = new Swiper(this.viewport, {
            init: false,
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: parseFloat(styles.getPropertyValue('--scene-gap-mobile')) || 0,
            breakpoints: { 769: { spaceBetween: parseFloat(styles.getPropertyValue('--scene-gap')) || 0 } },
            speed: this.reducedMotion.matches ? 0 : Number(this.dataset.speed),
            loop,
            loopAdditionalSlides: 1,
            watchOverflow: true,
            a11y: false,
            on: {
              init: () => this.update(false),
              slideChange: () => this.update(),
              resize: () => this.update(false),
            },
          });

          this.addEventListener('click', (event) => {
            const button = event.target.closest('[data-scene-action]');
            if (!button || !this.contains(button)) return;
            if (button.dataset.sceneAction === 'previous') this.swiper.slidePrev();
            else this.swiper.slideNext();
          }, { signal });

          this.viewport.addEventListener('keydown', (event) => {
            if (event.target !== this.viewport) return;
            const rtl = getComputedStyle(this).direction === 'rtl';
            if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
              event.preventDefault();
              if ((event.key === 'ArrowLeft') !== rtl) this.swiper.slidePrev();
              else this.swiper.slideNext();
            } else if (event.key === 'Home' || event.key === 'End') {
              event.preventDefault();
              this.goTo(event.key === 'Home' ? 0 : this.captions.length - 1);
            }
          }, { signal });

          this.mobile.addEventListener('change', () => this.pauseVideos(), { signal });
          this.reducedMotion.addEventListener('change', () => {
            this.swiper.params.speed = this.reducedMotion.matches ? 0 : Number(this.dataset.speed);
          }, { signal });
          document.addEventListener('visibilitychange', () => {
            if (document.hidden) this.pauseVideos();
          }, { signal });
          document.addEventListener('shopify:block:select', (event) => {
            const slide = this.slides.find((item) => item.dataset.blockId === event.detail.blockId);
            if (slide) this.goTo(Number(slide.dataset.sceneSlide), 0);
          }, { signal });

          this.observer = new IntersectionObserver((entries) => {
            if (!entries[0].isIntersecting) this.pauseVideos();
          });
          this.observer.observe(this.viewport);
          this.setAttribute('data-ready', '');
          this.swiper.init();
          const controls = this.querySelector('[data-scene-controls]');
          if (controls) controls.hidden = false;
        }

        goTo(index, speed = this.swiper.params.speed) {
          if (this.swiper.params.loop) {
            const groupStart = Math.floor(this.swiper.realIndex / this.captions.length) * this.captions.length;
            this.swiper.slideToLoop(groupStart + index, speed);
          } else this.swiper.slideTo(index, speed);
        }

        update(announce = true) {
          const activeSlide = this.swiper.slides[this.swiper.activeIndex];
          const index = Number(activeSlide.dataset.sceneSlide);
          for (const slide of this.slides) {
            const active = slide === activeSlide;
            slide.inert = !active;
            slide.setAttribute('aria-hidden', String(!active));
          }
          for (const [captionIndex, caption] of this.captions.entries()) caption.hidden = captionIndex !== index;
          for (const button of this.buttons) {
            button.disabled = this.swiper.isLocked || (
              !this.swiper.params.loop && !this.swiper.params.rewind && (
                button.dataset.sceneAction === 'previous' ? this.swiper.isBeginning : this.swiper.isEnd
              )
            );
          }
          if (announce) this.status.textContent = activeSlide.dataset.label;
          this.pauseVideos();
        }

        pauseVideos() {
          for (const video of this.videos) video.pause();
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.frame);
          this.controller?.abort();
          this.observer?.disconnect();
          for (const video of this.videos || []) video.pause();
          this.swiper?.destroy(true, true);
          this.swiper = null;
          this.removeAttribute('data-ready');
        }
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', register, { once: true });
    else register();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autofull-swiper"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const register = () => {
      if (customElements.get('autofull-swiper')) return;

      customElements.define('autofull-swiper', class extends HTMLElement {
        connectedCallback() {
          this.frame = requestAnimationFrame(() => this.initialize());
        }

        initialize() {
          this.viewport = this.querySelector('[data-af-viewport]');
          if (!this.viewport || this.swiper) return;

          this.controller = new AbortController();
          const { signal } = this.controller;
          this.slides = [...this.querySelectorAll('[data-af-slide]')];
          this.tabs = [...this.querySelectorAll('[data-af-tab]')];
          this.tabDescriptions = [...this.querySelectorAll('[data-af-tab-description]')];
          this.tabDescriptionsContainer = this.querySelector('[data-af-tab-descriptions]');
          this.buttons = [...this.querySelectorAll('[data-af-action]')];
          this.videos = [...this.querySelectorAll('video')];
          this.status = this.querySelector('[data-af-status]');
          this.breakpoint = matchMedia('(min-width: 1150px)');
          this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
          this.visible = false;
          const styles = getComputedStyle(this);
          const desktopGap = parseFloat(styles.getPropertyValue('--af-gap')) || 0;
          const mobileGap = parseFloat(styles.getPropertyValue('--af-gap-mobile')) || 0;
          const isTabs = this.dataset.mode === 'tabs';

          this.setAttribute('data-ready', '');
          this.swiper = new Swiper(this.viewport, {
            effect: isTabs ? 'fade' : 'slide',
            fadeEffect: { crossFade: true },
            slidesPerView: isTabs ? 1 : 'auto',
            allowTouchMove: !isTabs,
            spaceBetween: isTabs ? 0 : mobileGap,
            speed: this.reducedMotion.matches ? 0 : Number(this.dataset.speed),
            rewind: this.dataset.loop === 'true' && this.slides.length > 1,
            watchOverflow: true,
            a11y: false,
            breakpoints: { 1150: { spaceBetween: isTabs ? 0 : desktopGap } },
            on: { slideChange: () => this.update(), resize: () => this.update(false) },
          });

          this.addEventListener('click', (event) => {
            const action = event.target.closest('[data-af-action]');
            if (action && this.contains(action)) {
              if (action.dataset.afAction === 'previous') this.swiper.slidePrev();
              else this.swiper.slideNext();
            }
            const tab = event.target.closest('[data-af-tab]');
            if (tab && this.contains(tab)) this.swiper.slideTo(Number(tab.dataset.afTab));
          }, { signal });

          this.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
          this.breakpoint.addEventListener('change', () => this.updateVideos(), { signal });
          this.reducedMotion.addEventListener('change', () => {
            this.swiper.params.speed = this.reducedMotion.matches ? 0 : Number(this.dataset.speed);
            this.updateVideos();
          }, { signal });
          document.addEventListener('visibilitychange', () => this.updateVideos(), { signal });
          document.addEventListener('shopify:block:select', (event) => {
            const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
            if (index !== -1) this.swiper.slideTo(index, 0);
          }, { signal });

          this.observer = new IntersectionObserver((entries) => {
            this.visible = entries[0].isIntersecting;
            this.updateVideos();
          }, { threshold: 0.1 });
          this.observer.observe(this.viewport);
          for (const element of this.querySelectorAll('[data-af-ui]')) element.hidden = false;
          this.update(false);
        }

        /** @param {KeyboardEvent} event */
        handleKeydown(event) {
          const tab = event.target.closest('[data-af-tab]');
          if (!tab && event.target !== this.viewport) return;
          const rtl = getComputedStyle(this).direction === 'rtl';
          const direction = rtl ? -1 : 1;
          let index = tab ? Number(tab.dataset.afTab) : this.swiper.activeIndex;
          if (event.key === 'ArrowRight') index += direction;
          else if (event.key === 'ArrowLeft') index -= direction;
          else if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = this.slides.length - 1;
          else return;
          event.preventDefault();
          if (tab || this.dataset.loop === 'true') index = (index + this.slides.length) % this.slides.length;
          else index = Math.max(0, Math.min(index, this.slides.length - 1));
          this.swiper.slideTo(index);
          if (tab) this.tabs[index].focus({ preventScroll: true });
        }

        /** @param {boolean} announce Whether to announce the current slide. */
        update(announce = true) {
          if (!this.swiper) return;
          const index = this.swiper.activeIndex;
          const media = this.slides[index]?.querySelector('.autofull-swiper__media');
          if (media) this.style.setProperty('--af-active-media-height', `${media.getBoundingClientRect().height}px`);
          for (const [slideIndex, slide] of this.slides.entries()) {
            const active = slideIndex === index;
            slide.inert = !active;
            slide.setAttribute('aria-hidden', String(!active));
            if (this.dataset.mode === 'tabs') slide.tabIndex = active ? 0 : -1;
          }
          for (const [tabIndex, tab] of this.tabs.entries()) {
            tab.setAttribute('aria-selected', String(tabIndex === index));
            tab.tabIndex = tabIndex === index ? 0 : -1;
          }
          let hasTabDescription = false;
          for (const description of this.tabDescriptions) {
            const active = Number(description.dataset.afTabDescription) === index;
            description.hidden = !active;
            if (active) hasTabDescription = true;
          }
          if (this.tabDescriptionsContainer) this.tabDescriptionsContainer.hidden = !hasTabDescription;
          for (const button of this.buttons) {
            button.disabled = this.swiper.isLocked || (
              this.dataset.loop !== 'true' && (
                button.dataset.afAction === 'previous' ? this.swiper.isBeginning : this.swiper.isEnd
              )
            );
          }
          const tab = this.tabs[index];
          const scroller = this.querySelector('[data-af-tabs-scroll]');
          if (tab && scroller) {
            const tabRect = tab.getBoundingClientRect();
            const scrollRect = scroller.getBoundingClientRect();
            if (tabRect.left < scrollRect.left || tabRect.right > scrollRect.right) {
              scroller.scrollBy({ left: tabRect.left - scrollRect.left - (scrollRect.width - tabRect.width) / 2, behavior: 'auto' });
            }
          }
          if (announce && this.status) this.status.textContent = this.slides[index]?.dataset.label || '';
          this.updateVideos();
        }

        updateVideos() {
          for (const video of this.videos) video.pause();
          if (!this.visible || document.hidden || this.dataset.videoAutoplay !== 'true' || this.reducedMotion.matches) return;
          const slide = this.slides[this.swiper.activeIndex];
          for (const video of slide.querySelectorAll('video')) {
            if (!video.getClientRects().length) continue;
            video.muted = true;
            const playback = video.play();
            if (playback) playback.catch(() => {});
          }
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.frame);
          this.controller?.abort();
          this.observer?.disconnect();
          for (const video of this.videos || []) video.pause();
          this.swiper?.destroy(true, true);
          this.swiper = null;
          this.removeAttribute('data-ready');
        }
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', register, { once: true });
    else register();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autofull-tab-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const register = () => {
      if (customElements.get('autofull-tab-slider')) return;

      customElements.define('autofull-tab-slider', class extends HTMLElement {
        connectedCallback() {
          this.frame = requestAnimationFrame(() => this.initialize());
        }

        initialize() {
          const viewport = this.querySelector('[data-tab-slider-viewport]');
          if (!viewport || this.swiper) return;

          this.controller = new AbortController();
          const { signal } = this.controller;
          this.slides = [...this.querySelectorAll('[data-tab-slider-slide]')];
          this.tabs = [...this.querySelectorAll('[data-tab-slider-tab]')];
          this.captions = [...this.querySelectorAll('[data-tab-slider-caption]')];
          this.buttons = [...this.querySelectorAll('[data-tab-slider-action]')];
          this.videos = [...this.querySelectorAll('video')];
          this.tablist = this.querySelector('[data-tab-slider-tabs]');
          this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

          this.swiper = new Swiper(viewport, {
            init: false,
            slidesPerView: 1,
            speed: this.reducedMotion.matches ? 0 : Math.max(0, Number(this.dataset.speed) || 0),
            rewind: this.dataset.rewind === 'true',
            watchOverflow: true,
            a11y: false,
            on: {
              init: () => this.update(),
              slideChange: () => this.update(),
              resize: () => this.update(),
            },
          });

          this.addEventListener('click', (event) => {
            const tab = event.target.closest('[data-tab-slider-tab]');
            if (tab && this.contains(tab)) {
              this.swiper.slideTo(Number(tab.dataset.tabSliderTab));
              return;
            }
            const button = event.target.closest('[data-tab-slider-action]');
            if (!button || !this.contains(button)) return;
            if (button.dataset.tabSliderAction === 'previous') this.swiper.slidePrev();
            else this.swiper.slideNext();
          }, { signal });

          this.tablist.addEventListener('keydown', (event) => {
            const tab = event.target.closest('[data-tab-slider-tab]');
            if (!tab) return;
            const index = this.tabs.indexOf(tab);
            const rtl = getComputedStyle(this).direction === 'rtl';
            let nextIndex;
            if (event.key === 'Home') nextIndex = 0;
            else if (event.key === 'End') nextIndex = this.tabs.length - 1;
            else if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
              const step = (event.key === 'ArrowRight') !== rtl ? 1 : -1;
              nextIndex = (index + step + this.tabs.length) % this.tabs.length;
            } else return;
            event.preventDefault();
            this.tabs[nextIndex].focus({ preventScroll: true });
            this.swiper.slideTo(nextIndex);
          }, { signal });

          this.reducedMotion.addEventListener('change', () => {
            this.swiper.params.speed = this.reducedMotion.matches ? 0 : Math.max(0, Number(this.dataset.speed) || 0);
          }, { signal });
          document.addEventListener('shopify:block:select', (event) => {
            const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
            if (index !== -1) this.swiper.slideTo(index, 0);
          }, { signal });
          document.addEventListener('visibilitychange', () => {
            if (document.hidden) this.pauseVideos();
          }, { signal });
          matchMedia('(max-width: 768px)').addEventListener('change', () => this.pauseVideos(), { signal });

          this.observer = new IntersectionObserver((entries) => {
            if (!entries[0].isIntersecting) this.pauseVideos();
          });
          this.observer.observe(viewport);
          this.setAttribute('data-ready', '');
          this.swiper.init();
          const arrows = this.querySelector('[data-tab-slider-arrows]');
          if (arrows) arrows.hidden = false;
        }

        update() {
          const index = this.swiper.activeIndex;
          for (const [slideIndex, slide] of this.slides.entries()) {
            const active = slideIndex === index;
            if (!active && slide.contains(document.activeElement)) this.tabs[index].focus({ preventScroll: true });
            slide.inert = !active;
            slide.setAttribute('aria-hidden', String(!active));
          }
          for (const [tabIndex, tab] of this.tabs.entries()) {
            const active = tabIndex === index;
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
          }
          for (const [captionIndex, caption] of this.captions.entries()) caption.hidden = captionIndex !== index;
          for (const button of this.buttons) {
            button.disabled = this.swiper.isLocked || (!this.swiper.params.rewind && (
              button.dataset.tabSliderAction === 'previous' ? this.swiper.isBeginning : this.swiper.isEnd
            ));
          }
          const activeTab = this.tabs[index];
          const left = activeTab.offsetLeft - (this.tablist.clientWidth - activeTab.offsetWidth) / 2;
          this.tablist.scrollTo({ left, behavior: 'instant' });
          this.pauseVideos();
        }

        pauseVideos() {
          for (const video of this.videos || []) video.pause();
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.frame);
          this.controller?.abort();
          this.observer?.disconnect();
          this.pauseVideos();
          this.swiper?.destroy(true, true);
          this.swiper = null;
          this.removeAttribute('data-ready');
        }
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', register, { once: true });
    else register();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autofull-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-e3-ultra-media]';

    function init(root) {
      if (root.dataset.e3UltraMediaReady) return;
      root.dataset.e3UltraMediaReady = 'true';

      const preview = root.querySelector('.e3-ultra-media__preview-video');
      const dialog = root.querySelector('.e3-ultra-media__dialog');
      const popup = root.querySelector('video.e3-ultra-media__popup-video');
      const youtube = root.querySelector('[data-e3-ultra-media-youtube]');
      const openButton = root.querySelector('[data-e3-ultra-media-open]');
      const closeButton = root.querySelector('[data-e3-ultra-media-close]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const controller = new AbortController();
      const options = { signal: controller.signal };
      let closeAnimation;
      let closing = false;
      let isVisible = true;
      let observer;

      function syncPreview() {
        if (!preview) return;
        if (document.hidden || !isVisible || dialog?.open || reducedMotion.matches) {
          preview.pause();
        } else if (preview.paused) {
          preview.play().catch(() => {});
        }
      }

      function open() {
        if (!dialog || dialog.open) return;
        closeAnimation?.cancel();
        dialog.showModal();
        preview?.pause();
        closeButton.focus({ preventScroll: true });
        if (youtube) {
          youtube.src = youtube.dataset.src;
        } else if (popup) {
          popup.currentTime = 0;
          popup.play().catch(() => {});
        }
        if (!reducedMotion.matches) {
          dialog.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 220, easing: 'ease-out' });
          root.querySelector('.e3-ultra-media__player')?.animate(
            [{ opacity: 0, transform: 'translateY(12px) scale(0.98)' }, { opacity: 1, transform: 'translateY(0) scale(1)' }],
            { duration: 240, easing: 'ease-out' }
          );
        }
      }

      async function close() {
        if (!dialog?.open || closing) return;
        closing = true;
        popup?.pause();
        youtube?.removeAttribute('src');
        if (!reducedMotion.matches) {
          closeAnimation = dialog.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 180, easing: 'ease-in', fill: 'forwards' });
          try { await closeAnimation.finished; } catch (error) { /* Section may be removed during animation. */ }
        }
        if (dialog.open) dialog.close();
        closeAnimation?.cancel();
        closeAnimation = null;
        if (popup) popup.currentTime = 0;
        openButton?.focus({ preventScroll: true });
        closing = false;
        syncPreview();
      }

      openButton?.addEventListener('click', open, options);
      closeButton?.addEventListener('click', close, options);
      dialog?.addEventListener('cancel', (event) => {
        event.preventDefault();
        close();
      }, options);
      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) close();
      }, options);
      document.addEventListener('visibilitychange', syncPreview, options);
      reducedMotion.addEventListener('change', syncPreview, options);

      if (preview && 'IntersectionObserver' in window) {
        observer = new IntersectionObserver((entries) => {
          isVisible = entries[0]?.isIntersecting ?? false;
          syncPreview();
        });
        observer.observe(root);
      }
      syncPreview();

      root.e3UltraMediaCleanup = () => {
        controller.abort();
        observer?.disconnect();
        closeAnimation?.cancel();
        preview?.pause();
        popup?.pause();
        youtube?.removeAttribute('src');
        if (dialog?.open) dialog.close();
        delete root.dataset.e3UltraMediaReady;
        delete root.e3UltraMediaCleanup;
      };
    }

    function initAll(scope = document) {
      if (scope.matches?.(selector)) init(scope);
      for (const root of scope.querySelectorAll(selector)) init(root);
    }

    document.addEventListener('DOMContentLoaded', () => initAll());
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.matches?.(selector)) event.target.e3UltraMediaCleanup?.();
      for (const root of event.target.querySelectorAll(selector)) root.e3UltraMediaCleanup?.();
    });
    if (document.readyState !== 'loading') initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autofull-whats-in-box"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = () => {
      if (customElements.get('autofull-whats-in-box')) return;

      class AutofullWhatsInBox extends HTMLElement {
        connectedCallback() {
          this.controller?.abort();
          this.controller = new AbortController();
          this.items = [...this.querySelectorAll('[data-box-item]')];
          this.buttons = [...this.querySelectorAll('[data-box-version]')];
          this.versions = this.querySelector('[data-box-versions]');
          this.more = this.querySelector('[data-box-more]');
          this.version = this.versions ? this.dataset.defaultVersion || 'standard' : 'standard';
          this.expandedVersions = new Set();
          const options = { signal: this.controller.signal };

          this.buttons.forEach(button => button.addEventListener('click', () => {
            this.version = button.dataset.boxVersion;
            this.update();
          }, options));

          this.more.addEventListener('click', () => {
            if (this.expandedVersions.has(this.version)) {
              this.expandedVersions.delete(this.version);
            } else {
              this.expandedVersions.add(this.version);
            }
            this.update();
          }, options);

          document.addEventListener('shopify:block:select', event => {
            const item = event.target.closest('[data-box-item]');
            if (!item || !this.contains(item)) return;
            if (this.versions && item.dataset.version !== 'both') this.version = item.dataset.version;
            this.expandedVersions.add(this.version);
            this.update();
          }, options);

          if (this.versions) this.versions.hidden = false;
          this.dataset.enhanced = '';
          this.update();
        }

        disconnectedCallback() {
          this.controller?.abort();
        }

        update() {
          const expanded = this.expandedVersions.has(this.version);
          const limit = Math.max(1, Number(this.dataset.mobileLimit) || 6);
          let count = 0;

          this.items.forEach(item => {
            const matches = item.dataset.version === 'both' || item.dataset.version === this.version;
            item.hidden = !matches;
            item.classList.toggle('autofull-box__item--extra', matches && ++count > limit && !expanded);
          });

          this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.boxVersion === this.version)));
          this.querySelector('[data-box-empty]').hidden = count > 0;
          this.more.hidden = count <= limit;
          this.more.setAttribute('aria-expanded', String(expanded));
          this.more.querySelector('[data-box-more-label]').hidden = expanded;
          this.more.querySelector('[data-box-less-label]').hidden = !expanded;
        }
      }

      customElements.define('autofull-whats-in-box', AutofullWhatsInBox);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBlogBannerNewsletterForms = (scope = document) => {
      scope.querySelectorAll('form[id^="blog-banner-newsletter-"]').forEach((form) => {
        if (form.dataset.loadingInitialized === 'true') return;

        form.dataset.loadingInitialized = 'true';
        form.addEventListener('submit', () => {
          const button = form.querySelector('[data-blog-banner-submit]');

          if (!button || button.disabled) return;

          button.classList.add('is-loading');
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initBlogBannerNewsletterForms());
    } else {
      initBlogBannerNewsletterForms();
    }

    document.addEventListener('shopify:section:load', (event) => initBlogBannerNewsletterForms(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bulk-contact"] && !Shopify.designMode) return;
  try {
    
  const registerBulkContactForm = () => {
    if (customElements.get('bulk-contact-form')) return;

    class BulkContactForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('.bulk-contact__submit');

        if (!this.form || !this.submitButton) return;

        this.handleSubmit = this.handleSubmit.bind(this);
        this.form.addEventListener('submit', this.handleSubmit);
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.handleSubmit);
      }

      handleSubmit() {
        if (!this.form.checkValidity()) return;

        this.submitButton.disabled = true;
        this.submitButton.classList.add('is-loading');
        this.submitButton.setAttribute('aria-busy', 'true');
        this.submitButton.setAttribute('aria-label', this.dataset.loadingLabel);
      }
    }

    customElements.define('bulk-contact-form', BulkContactForm);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registerBulkContactForm, { once: true });
  } else {
    registerBulkContactForm();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-banner-nav"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.collection-banner-nav').forEach((section) => {
      const details = section.querySelector('[data-collection-banner-nav-details]');

      if (details) {
        document.addEventListener('click', (event) => {
          if (!details.open || details.contains(event.target)) return;
          details.removeAttribute('open');
        });

        details.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            details.removeAttribute('open');
            const summary = details.querySelector('summary');
            if (summary) summary.focus();
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-compare"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    for (const section of document.querySelectorAll('.collection-compare')) {
      const viewport = section.querySelector('[data-compare-viewport]');
      const thumb = section.querySelector('[data-compare-scrollbar-thumb]');

      if (!viewport || !thumb) {
        continue;
      }

      const scrollbar = thumb.parentElement;

      const updateThumb = () => {
        const scrollable = viewport.scrollWidth - viewport.clientWidth;
        scrollbar.classList.toggle('collection-compare__scrollbar--scrollable', scrollable > 0);

        if (scrollable <= 0) {
          thumb.style.width = '100%';
          thumb.style.transform = 'translateX(0)';
          return;
        }

        const trackWidth = scrollbar.clientWidth;
        const thumbWidth = Math.max((viewport.clientWidth / viewport.scrollWidth) * trackWidth, 48);
        const maxThumbOffset = trackWidth - thumbWidth;
        const progress = viewport.scrollLeft / scrollable;

        thumb.style.width = `${thumbWidth}px`;
        thumb.style.transform = `translateX(${maxThumbOffset * progress}px)`;
      };

      viewport.addEventListener('scroll', updateThumb, { passive: true });
      window.addEventListener('resize', updateThumb);
      updateThumb();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["esport-zone-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const GLOBAL_KEY = '__esportZoneBannerMotionBooted';
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const getSectionProgress = (section) => clamp(-section.getBoundingClientRect().top / (window.innerHeight * 2), 0, 1);
    const TRIGGER_SHOW_THRESHOLD = 0.12;
    const TRIGGER_RESET_THRESHOLD = 0.04;

    const createTriggeredMaskController = (section, maskTarget, motion) => {
      if (!maskTarget) {
        return null;
      }

      const SCALE_FROM = 6;
      const SCALE_TO = 1.01;
      const EASING = [0.22, 1, 0.36, 1];
      let animation = null;
      let ticking = false;
      let lastProgress = getSectionProgress(section);
      let state = lastProgress >= TRIGGER_SHOW_THRESHOLD ? 'shown' : 'hidden';

      const stopAnimation = () => {
        if (!animation) {
          return;
        }

        if (typeof animation.stop === 'function') {
          animation.stop();
        } else if (typeof animation.cancel === 'function') {
          animation.cancel();
        }

        animation = null;
      };

      const setMaskState = (isShown) => {
        maskTarget.style.opacity = isShown ? '1' : '0';
        maskTarget.style.transform = 'translateZ(0) scale(' + (isShown ? SCALE_TO : SCALE_FROM) + ')';
      };

      setMaskState(state === 'shown');

      const animateMask = (isShowing) => {
        stopAnimation();

        const keyframes = {
          transform: [
            'translateZ(0) scale(' + (isShowing ? SCALE_FROM : SCALE_TO) + ')',
            'translateZ(0) scale(' + (isShowing ? SCALE_TO : SCALE_FROM) + ')',
          ],
          opacity: isShowing ? [0, 1] : [1, 0],
        };

        if (motion && motion.animate) {
          animation = motion.animate(maskTarget, keyframes, {
            duration: isShowing ? 0.72 : 0.42,
            easing: EASING,
            fill: 'forwards',
          });
          return;
        }

        if (maskTarget.animate) {
          animation = maskTarget.animate(keyframes, {
            duration: isShowing ? 720 : 420,
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
            fill: 'forwards',
          });
          return;
        }

        setMaskState(isShowing);
      };

      const triggerShow = () => {
        if (state === 'shown') return;
        state = 'shown';
        animateMask(true);
      };

      const triggerHide = () => {
        if (state === 'hidden') return;
        state = 'hidden';
        animateMask(false);
      };

      const update = () => {
        const progress = getSectionProgress(section);
        const direction = progress - lastProgress;

        if (direction > 0 && progress >= TRIGGER_SHOW_THRESHOLD) {
          triggerShow();
        } else if (direction < 0 && progress <= TRIGGER_RESET_THRESHOLD) {
          triggerHide();
        }

        lastProgress = progress;
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          update();
          ticking = false;
        });
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);

      return {
        stop: () => {
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onScroll);
          stopAnimation();
        },
      };
    };

    const createTriggeredContentController = (section, contentElements, motion) => {
      const animationTargets = [
        {
          element: contentElements.logo,
          distance: 0,
          delay: 0,
        },
        {
          element: contentElements.title,
          distance: -110,
          delay: 0.04,
        },
        {
          element: contentElements.button,
          distance: -72,
          delay: 0.08,
        },
      ].filter((target) => target.element);

      if (!animationTargets.length) {
        return null;
      }

      const EASING = [0.22, 1, 0.36, 1];
      const animations = [];
      let state = 'shown';
      let lastProgress = getSectionProgress(section);
      let ticking = false;

      const stopAnimations = () => {
        animations.forEach((animation) => {
          if (animation && typeof animation.stop === 'function') {
            animation.stop();
          } else if (animation && typeof animation.cancel === 'function') {
            animation.cancel();
          }
        });
        animations.length = 0;
      };

      const setContentState = (isShown) => {
        animationTargets.forEach(({ element, distance }) => {
          element.style.opacity = isShown ? '1' : '0';
          element.style.transform = distance ? `translate3d(0, ${isShown ? 0 : distance}px, 0)` : 'none';
          element.style.willChange = distance ? 'transform, opacity' : 'opacity';
        });
      };

      const runContentAnimation = (isShowing) => {
        stopAnimations();

        animationTargets.forEach(({ element, distance, delay }) => {
          const keyframes = {
            opacity: isShowing ? [0, 1] : [1, 0],
          };

          if (distance) {
            keyframes.transform = isShowing
              ? [`translate3d(0, ${distance}px, 0)`, 'translate3d(0, 0, 0)']
              : ['translate3d(0, 0, 0)', `translate3d(0, ${distance}px, 0)`];
          }

          if (motion && motion.animate) {
            const control = motion.animate(element, keyframes, {
              duration: 0.58,
              easing: EASING,
              fill: 'forwards',
              delay,
            });
            animations.push(control);
          } else if (element.animate) {
            const control = element.animate(keyframes, {
              duration: 580,
              easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
              fill: 'forwards',
              delay: delay * 1000,
            });
            animations.push(control);
          } else {
            element.style.opacity = isShowing ? '1' : '0';
            if (distance) {
              element.style.transform = isShowing ? 'translate3d(0, 0, 0)' : `translate3d(0, ${distance}px, 0)`;
            }
          }
        });
      };

      if (lastProgress >= TRIGGER_SHOW_THRESHOLD) {
        state = 'hidden';
        setContentState(false);
      } else {
        setContentState(true);
      }

      const triggerHide = () => {
        if (state === 'hidden') return;
        state = 'hidden';
        runContentAnimation(false);
      };

      const triggerShow = () => {
        if (state === 'shown') return;
        state = 'shown';
        runContentAnimation(true);
      };

      const update = () => {
        const progress = getSectionProgress(section);
        const direction = progress - lastProgress;

        if (direction > 0 && progress >= TRIGGER_SHOW_THRESHOLD) {
          triggerHide();
        } else if (direction < 0 && progress <= TRIGGER_RESET_THRESHOLD) {
          triggerShow();
        }

        lastProgress = progress;
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          update();
          ticking = false;
        });
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);

      return {
        stop: () => {
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onScroll);
          stopAnimations();
        },
      };
    };

    const setupSection = (section) => {
      if (!section) return;

      if (section.__esportZoneCleanup) {
        section.__esportZoneCleanup();
      }

      const content = section.querySelector('.esport-zone-banner__content');
      const maskLayer = section.querySelector('[data-esport-zone-mask-layer]');
      const maskFallback = section.querySelector('.esport-zone-banner__mask-fallback');
      const contentElements = {
        logo: content ? content.querySelector('[data-esport-zone-content-logo]') : null,
        title: content ? content.querySelector('[data-esport-zone-content-title]') : null,
        button: content ? content.querySelector('[data-esport-zone-content-button]') : null,
      };
      const hasMaskLayer = maskLayer && getComputedStyle(maskLayer).display !== 'none';
      const maskTarget = hasMaskLayer ? maskLayer : maskFallback;
      const modal = section.querySelector('[data-esport-zone-modal]');
      const openButton = section.querySelector('[data-esport-zone-modal-open]');
      const closeButtons = modal ? Array.from(modal.querySelectorAll('[data-esport-zone-modal-close]')) : [];
      const modalVideo = modal ? modal.querySelector('video') : null;

      const motion = window.Motion || {};
      const controls = [];

      const maskTriggerControl = createTriggeredMaskController(section, maskTarget, motion);
      if (maskTriggerControl) {
        controls.push(maskTriggerControl);
      }

      const contentTriggerControl = createTriggeredContentController(section, contentElements, motion);
      if (contentTriggerControl) {
        controls.push(contentTriggerControl);
      }

      if (modal && openButton) {
        let closeTimer = null;
        const rootElement = document.documentElement;

        const openModal = () => {
          if (openButton.hasAttribute('disabled')) return;

          if (closeTimer) {
            window.clearTimeout(closeTimer);
            closeTimer = null;
          }

          modal.hidden = false;
          requestAnimationFrame(() => {
            modal.classList.add('is-open');
          });

          rootElement.classList.add('esport-zone-banner-modal-open');

          if (modalVideo) {
            modalVideo.muted = false;
            modalVideo.controls = true;
            modalVideo.currentTime = 0;
            const playPromise = modalVideo.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {});
            }
          }
        };

        const closeModal = () => {
          modal.classList.remove('is-open');
          rootElement.classList.remove('esport-zone-banner-modal-open');

          if (modalVideo) {
            modalVideo.pause();
          }

          if (closeTimer) {
            window.clearTimeout(closeTimer);
          }

          closeTimer = window.setTimeout(() => {
            modal.hidden = true;
          }, 340);
        };

        const onKeydown = (event) => {
          if (event.key === 'Escape' && !modal.hidden) {
            closeModal();
          }
        };

        openButton.addEventListener('click', openModal);
        closeButtons.forEach((button) => button.addEventListener('click', closeModal));
        document.addEventListener('keydown', onKeydown);

        controls.push(() => {
          openButton.removeEventListener('click', openModal);
          closeButtons.forEach((button) => button.removeEventListener('click', closeModal));
          document.removeEventListener('keydown', onKeydown);
          if (closeTimer) {
            window.clearTimeout(closeTimer);
          }
          rootElement.classList.remove('esport-zone-banner-modal-open');
          modal.classList.remove('is-open');
          modal.hidden = true;
          if (modalVideo) {
            modalVideo.pause();
          }
        });
      }

      section.__esportZoneCleanup = () => {
        controls.forEach((control) => {
          if (typeof control === 'function') {
            control();
          } else if (control && typeof control.stop === 'function') {
            control.stop();
          }
        });
      };
    };

    const initAll = () => {
      const sections = document.querySelectorAll('[data-esport-zone-banner]');
      sections.forEach((section) => setupSection(section));
    };

    const boot = () => {
      initAll();

      if (!window.Motion || !window.Motion.animate) {
        let retries = 0;
        const timer = window.setInterval(() => {
          retries += 1;

          if (window.Motion && window.Motion.animate) {
            window.clearInterval(timer);
            initAll();
            return;
          }

          if (retries >= 60) {
            window.clearInterval(timer);
          }
        }, 100);
      }

      if (!window[GLOBAL_KEY]) {
        window[GLOBAL_KEY] = true;

        document.addEventListener('shopify:section:load', (event) => {
          const target =
            event.target && event.target.matches('[data-esport-zone-banner]')
              ? event.target
              : event.target
              ? event.target.querySelector('[data-esport-zone-banner]')
              : null;

          if (target) {
            setupSection(target);
          }
        });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('click', (event) => {
      const gift = event.target.closest('.event-banner [data-open-shop-ahead-dialog]');
      if (!gift) return;

      const opener = document.querySelector('[data-shop-ahead]')?.querySelector('[data-open-dialog]');
      if (!opener) return;

      gift.setAttribute('aria-controls', opener.dataset.openDialog);
      gift.focus({ preventScroll: true });
      opener.click();
    });

    window.addEventListener('load', () => {
      for (const success of document.querySelectorAll('.event-banner__success[data-newsletter-success]')) {
        if (window.location.hash === `#${success.closest('form').id}`) {
          success.focus({ preventScroll: true });
        }
      }
    }, { once: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-code-countdown"] && !Shopify.designMode) return;
  try {
    
  const registerEventCodeCountdown = () => {
    if (customElements.get('event-code-countdown')) return;

    class EventCodeCountdown extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.copyButton = this.querySelector('[data-copy-code]');
        this.status = this.querySelector('[data-copy-status]');
        this.copyButton?.removeAttribute('disabled');
        this.copyButton?.addEventListener('click', () => this.copyCode(), { signal: this.controller.signal });

        const timestamp = Number(this.dataset.expirationTimestamp);
        if (!Number.isFinite(timestamp) || timestamp <= 0) return;

        const fields = ['days', 'hours', 'minutes', 'seconds'].map((unit) =>
          this.querySelector(`[data-countdown-${unit}]`)
        );
        const render = () => {
          const remaining = Math.max(0, timestamp * 1000 - Date.now());
          const seconds = Math.floor(remaining / 1000);
          const values = [
            Math.floor(seconds / 86400),
            Math.floor((seconds % 86400) / 3600),
            Math.floor((seconds % 3600) / 60),
            seconds % 60,
          ];
          for (const [index, field] of fields.entries()) {
            field.textContent = String(values[index]).padStart(2, '0');
          }
          if (remaining > 0) {
            this.countdownTimeout = window.setTimeout(render, 1000 - (Date.now() % 1000));
          }
        };
        render();
      }

      disconnectedCallback() {
        this.controller.abort();
        window.clearTimeout(this.countdownTimeout);
        window.clearTimeout(this.feedbackTimeout);
      }

      async copyCode() {
        const code = this.querySelector('[data-discount-code]').textContent;
        this.copyButton.disabled = true;
        this.status.textContent = '';
        window.clearTimeout(this.feedbackTimeout);

        try {
          try {
            await navigator.clipboard.writeText(code);
          } catch {
            // Support browsers that block the Clipboard API, including editor previews.
            this.copyWithSelection(code);
          }
          if (!this.isConnected) return;
          this.status.textContent = this.dataset.copiedText;
          this.feedbackTimeout = window.setTimeout(() => { this.status.textContent = ''; }, 2500);
        } catch {
          if (this.isConnected) this.status.textContent = this.dataset.copyErrorText;
        } finally {
          if (this.isConnected) this.copyButton.disabled = false;
        }
      }

      copyWithSelection(code) {
        const input = document.createElement('textarea');
        const activeElement = document.activeElement;
        input.value = code;
        input.readOnly = true;
        input.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none;font-size:16px;';
        document.body.append(input);
        try {
          input.focus({ preventScroll: true });
          input.select();
          input.setSelectionRange(0, input.value.length);
          if (!document.execCommand('copy')) throw new Error('Copy failed');
        } finally {
          input.remove();
          activeElement?.focus({ preventScroll: true });
        }
      }
    }

    customElements.define('event-code-countdown', EventCodeCountdown);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registerEventCodeCountdown, { once: true });
  } else {
    registerEventCodeCountdown();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-countdown"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const pad = (value) => String(Math.max(0, value)).padStart(2, '0');

    document.querySelectorAll('[data-event-countdown]').forEach((root) => {
      const expirationTimestamp = Number(root.dataset.expirationTimestamp);

      if (!Number.isFinite(expirationTimestamp) || expirationTimestamp <= 0) {
        return;
      }

      const expirationTime = expirationTimestamp * 1000;

      const daysEl = root.querySelector('[data-countdown-days]');
      const hoursEl = root.querySelector('[data-countdown-hours]');
      const minutesEl = root.querySelector('[data-countdown-minutes]');
      const secondsEl = root.querySelector('[data-countdown-seconds]');

      const render = () => {
        const remaining = Math.max(0, expirationTime - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        daysEl.textContent = pad(days);
        hoursEl.textContent = pad(hours);
        minutesEl.textContent = pad(minutes);
        secondsEl.textContent = pad(seconds);

        if (remaining > 0) {
          window.setTimeout(render, 1000 - (Date.now() % 1000));
        }
      };

      render();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-exclusive-row"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-event-exclusive-row] [data-open-spin]');
      if (!button) return;

      document.querySelector("button[id*='omnisend-form']")?.click();
      document.querySelector("div[class*='kl-teaser'] span[role='button']")?.click();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-kol"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-event-kol]').forEach((sectionEl) => {
      const swiperEl = sectionEl.querySelector('.swiper');

      if (!swiperEl) {
        return;
      }

      new Swiper(swiperEl, {
        slidesPerView: 'auto',
        navigation: {
          nextEl: sectionEl.querySelector('[data-next]'),
          prevEl: sectionEl.querySelector('[data-prev]'),
        },
      });

      sectionEl.querySelectorAll('[data-video-media]').forEach((mediaEl) => {
        const videoEl = mediaEl.querySelector('video');
        const toggleEl = mediaEl.querySelector('[data-video-toggle]');

        if (!videoEl || !toggleEl) {
          return;
        }

        const syncState = () => {
          const isPlaying = !videoEl.paused && !videoEl.ended;

          mediaEl.classList.toggle('is-playing', isPlaying);
          toggleEl.setAttribute('aria-hidden', isPlaying ? 'true' : 'false');
        };

        const playVideo = () => {
          document.querySelectorAll('[data-event-kol] video').forEach((otherVideoEl) => {
            if (otherVideoEl !== videoEl && !otherVideoEl.paused && !otherVideoEl.ended) {
              otherVideoEl.pause();
            }
          });

          const playPromise = videoEl.play();

          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(syncState);
          }
        };

        const pauseVideo = () => {
          if (!videoEl.paused && !videoEl.ended) {
            videoEl.pause();
          }
        };

        mediaEl.addEventListener('click', pauseVideo);
        toggleEl.addEventListener('click', (event) => {
          event.stopPropagation();
          playVideo();
        });
        videoEl.addEventListener('play', syncState);
        videoEl.addEventListener('pause', syncState);
        videoEl.addEventListener('ended', syncState);

        syncState();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-product-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();

    /** Initialize one section, including instances inserted by the theme editor. */
    const initialize = (root) => {
      if (instances.has(root)) return;
      const controller = new AbortController();
      const { signal } = controller;
      const grid = root.querySelector('[data-grid]');
      const cards = Array.from(root.querySelectorAll('[data-card]'));
      const tabs = Array.from(root.querySelectorAll('[data-tab]'));
      const panel = grid.parentElement;
      const navigation = root.querySelector('[data-navigation]');
      const previousButton = navigation?.querySelector('[data-direction="-1"]');
      const nextButton = navigation?.querySelector('[data-direction="1"]');
      const mobile = window.matchMedia('(max-width: 768px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const visibleCards = () => cards.filter((card) => !card.hidden);
      let frame = 0;

      const currentIndex = () => {
        const visible = visibleCards();
        const bounds = grid.getBoundingClientRect();
        const rtl = getComputedStyle(grid).direction === 'rtl';
        const inset = parseFloat(getComputedStyle(grid).paddingInlineStart) || 0;
        const edge = rtl ? bounds.right - inset : bounds.left + inset;
        let closest = 0;
        let distance = Infinity;
        for (const [index, card] of visible.entries()) {
          const cardBounds = card.getBoundingClientRect();
          const nextDistance = Math.abs(rtl ? edge - cardBounds.right : cardBounds.left - edge);
          if (nextDistance < distance) {
            closest = index;
            distance = nextDistance;
          }
        }
        return closest;
      };

      const updateNavigation = () => {
        if (!navigation || !previousButton || !nextButton) return;
        const visible = visibleCards();
        const index = currentIndex();
        navigation.hidden = !mobile.matches || visible.length < 2 || grid.scrollWidth <= grid.clientWidth + 1;
        previousButton.disabled = index === 0;
        nextButton.disabled = index >= visible.length - 1;
      };

      const scrollToCard = (card, animate = true) => {
        if (!card || !mobile.matches || root.dataset.columns !== '3') return;
        const bounds = grid.getBoundingClientRect();
        const cardBounds = card.getBoundingClientRect();
        const rtl = getComputedStyle(grid).direction === 'rtl';
        const inset = parseFloat(getComputedStyle(grid).paddingInlineStart) || 0;
        grid.scrollBy({
          left: rtl ? cardBounds.right - bounds.right + inset : cardBounds.left - bounds.left - inset,
          behavior: animate && !reducedMotion.matches ? 'smooth' : 'instant',
        });
      };

      const activateTab = (tab, focus = false) => {
        for (const item of tabs) {
          item.setAttribute('aria-selected', String(item === tab));
          item.tabIndex = item === tab ? 0 : -1;
        }
        for (const card of cards)
          card.hidden = Boolean(card.dataset.tabHandle && card.dataset.tabHandle !== tab.dataset.tab);
        panel.setAttribute('aria-labelledby', tab.id);
        if (focus) tab.focus();
        scrollToCard(visibleCards()[0], false);
        updateNavigation();
      };

      root.addEventListener(
        'click',
        (event) => {
          const tab = event.target.closest('[data-tab]');
          if (tab) activateTab(tab);
          const direction = event.target.closest('[data-direction]');
          if (direction) scrollToCard(visibleCards()[currentIndex() + Number(direction.dataset.direction)]);
        },
        { signal }
      );

      root.addEventListener(
        'keydown',
        (event) => {
          const tab = event.target.closest('[data-tab]');
          if (!tab) return;
          const index = tabs.indexOf(tab);
          const rtl = getComputedStyle(tab).direction === 'rtl';
          let next = index;
          if (event.key === 'ArrowRight') next += rtl ? -1 : 1;
          else if (event.key === 'ArrowLeft') next += rtl ? 1 : -1;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          activateTab(tabs[(next + tabs.length) % tabs.length], true);
        },
        { signal }
      );

      root.addEventListener(
        'change',
        (event) => {
          const input = event.target.closest('[data-variant]');
          if (!input) return;
          const card = input.closest('[data-card]');
          const variant = input.dataset;
          card.querySelector('[data-variant-title]').textContent = variant.title;
          card.querySelector('[data-price]').textContent = variant.price;
          card.querySelector('[data-compare]').textContent = variant.compare;
          const badgeAmount = card.querySelector('[data-badge-discount]');
          const currency = badgeAmount.dataset.badgeCurrency;
          if (currency && variant.badgeAmount.includes(currency)) {
            const currencyIndex = variant.badgeAmount.indexOf(currency);
            const currencyElement = document.createElement('span');
            currencyElement.className = 'event-product-grid__badge-currency';
            currencyElement.textContent = currency;
            badgeAmount.replaceChildren(
              variant.badgeAmount.slice(0, currencyIndex),
              currencyElement,
              variant.badgeAmount.slice(currencyIndex + currency.length)
            );
          } else badgeAmount.textContent = variant.badgeAmount;
          for (const element of card.querySelectorAll('span[data-discount]')) element.textContent = variant.discount;
          for (const element of card.querySelectorAll('[data-badge], [data-compare-wrap], [data-price-off]'))
            element.hidden = variant.hasDiscount !== 'true';
          for (const button of card.querySelectorAll('[data-add]')) {
            button.disabled = variant.available !== 'true';
            const label = button.querySelector('[data-add-label]');
            if (label) label.textContent = button.disabled ? root.dataset.soldOut : button.dataset.addText;
            const price = button.querySelector('[data-add-price]');
            if (price) {
              price.textContent = input.dataset.finalPrice;
              button.querySelector('.event-product-grid__add-content').hidden = button.disabled;
              label?.classList.toggle('sr-only', !button.disabled);
            }
          }
          for (const link of card.querySelectorAll('[data-product-link]')) link.href = variant.url;
          const picture = card.querySelector('[data-product-picture]:not([data-custom-image])');
          if (picture && variant.image) {
            const image = picture.querySelector('img');
            image.src = variant.image;
            image.removeAttribute('srcset');
            image.alt = variant.imageAlt;
          }
          card.querySelector('[data-error]').hidden = true;
        },
        { signal }
      );

      root.addEventListener(
        'cart:error',
        (event) => {
          const error = event.target.closest('[data-card]')?.querySelector('[data-error]');
          if (!error) return;
          error.textContent = event.detail.error;
          error.hidden = false;
        },
        { signal }
      );
      root.addEventListener(
        'submit',
        (event) => {
          const error = event.target.closest('[data-card]')?.querySelector('[data-error]');
          if (error) error.hidden = true;
        },
        { signal }
      );

      root.addEventListener(
        'shopify:block:select',
        (event) => {
          const card = event.target.closest('[data-card]');
          if (!card) return;
          const tab = tabs.find((item) => item.dataset.tab === card.dataset.tabHandle);
          if (tab) activateTab(tab);
          else if (card.hidden) {
            card.hidden = false;
            updateNavigation();
          }
          scrollToCard(card, false);
        },
        { signal }
      );

      grid.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(updateNavigation);
        },
        { passive: true, signal }
      );
      const observer = new ResizeObserver(updateNavigation);
      observer.observe(grid);
      mobile.addEventListener('change', updateNavigation, { signal });
      if (tabs.length) activateTab(tabs[0]);
      updateNavigation();
      instances.set(root, () => {
        controller.abort();
        observer.disconnect();
        cancelAnimationFrame(frame);
      });
    };

    const initializeAll = (scope) => {
      if (scope.matches?.('[data-event-product-grid]')) initialize(scope);
      for (const root of scope.querySelectorAll('[data-event-product-grid]')) initialize(root);
    };
    if (document.readyState === 'loading')
      document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
    else initializeAll(document);
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      for (const root of event.target.querySelectorAll('[data-event-product-grid]')) {
        instances.get(root)?.();
        instances.delete(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-shop-ahead"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const instances = new WeakMap();
    const initialize = (root) => {
      if (instances.has(root)) return;
      const controller = new AbortController();
      const { signal } = controller;
      const timers = new Set();
      const schedule = (callback, delay) => {
        const timer = window.setTimeout(() => { timers.delete(timer); callback(); }, delay);
        timers.add(timer);
      };
      const countdown = root.querySelector('[data-offer-countdown]');
      const end = Number(countdown?.dataset.endTimestamp) * 1000;
      const renderCountdown = () => {
        const remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
        const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining % 86400 / 3600), minutes: Math.floor(remaining % 3600 / 60), seconds: remaining % 60 };
        countdown.querySelectorAll('[data-time-unit]').forEach((element) => {
          element.textContent = String(values[element.dataset.timeUnit]).padStart(2, '0');
        });
        if (remaining > 0) schedule(renderCountdown, 1000 - Date.now() % 1000);
      };
      if (countdown && Number.isFinite(end) && end > 0) renderCountdown();
      const dialogs = [...root.querySelectorAll('[data-offer-dialog]')];
      const status = root.querySelector('[data-copy-status]');
      const closeDialog = async (dialog) => {
        if (!dialog.open || dialog.hasAttribute('data-closing')) return;
        dialog.setAttribute('data-closing', '');
        await Promise.allSettled(dialog.getAnimations().map((animation) => animation.finished));
        if (!signal.aborted && dialog.open) dialog.close();
        dialog.removeAttribute('data-closing');
      };
      const copyCode = async (button) => {
        const code = button.dataset.copyCode;
        if (!code || button.disabled || button.dataset.copying) return;
        button.dataset.copying = 'true';
        const label = button.textContent;
        const copyStatus = button.closest('dialog')?.querySelector('[data-copy-status]') || status;
        try {
          await navigator.clipboard.writeText(code);
          if (signal.aborted) return;
          button.textContent = root.dataset.copiedLabel;
          copyStatus.textContent = `${root.dataset.copiedLabel}: ${code}`;
          schedule(() => { button.textContent = label; delete button.dataset.copying; }, 2000);
        } catch {
          if (signal.aborted) return;
          copyStatus.textContent = `${root.dataset.copyError} ${code}`;
          button.textContent = code;
          schedule(() => { button.textContent = label; delete button.dataset.copying; }, 4000);
        }
      };
      root.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-open-dialog]');
        if (opener) {
          const dialog = dialogs.find((item) => item.id === opener.dataset.openDialog);
          if (dialog && !dialog.open) {
            dialog.showModal();
            dialog.querySelector('.event-shop-ahead__dialog-body').scrollTop = 0;
          }
          return;
        }
        const closer = event.target.closest('[data-close-dialog]');
        if (closer) { closeDialog(closer.closest('dialog')); return; }
        const copy = event.target.closest('[data-copy-code]');
        if (copy) copyCode(copy);
      }, { signal });
      dialogs.forEach((dialog) => {
        dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          closeDialog(dialog);
        }, { signal });
        dialog.addEventListener('keydown', (event) => {
          if (event.key !== 'Tab') return;
          const focusable = [...dialog.querySelectorAll('button:not(:disabled), a[href], [tabindex="0"]')];
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }, { signal });
        let backdropPressed = false;
        const isOutside = (event) => {
          const rect = dialog.getBoundingClientRect();
          return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
        };
        dialog.addEventListener('pointerdown', (event) => { backdropPressed = event.target === dialog && isOutside(event); }, { signal });
        dialog.addEventListener('click', (event) => {
          if (backdropPressed && event.target === dialog && isOutside(event)) closeDialog(dialog);
          backdropPressed = false;
        }, { signal });
        dialog.addEventListener('close', () => { dialog.querySelector('[data-copy-status]').textContent = ''; }, { signal });
      });
      instances.set(root, () => {
        dialogs.forEach((dialog) => { if (dialog.open) dialog.close(); });
        controller.abort();
        timers.forEach((timer) => window.clearTimeout(timer));
      });
    };
    const initializeWithin = (scope) => {
      if (scope.matches?.('[data-shop-ahead]')) initialize(scope);
      scope.querySelectorAll('[data-shop-ahead]').forEach(initialize);
    };
    initializeWithin(document);
    document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-shop-ahead]').forEach((root) => {
        instances.get(root)?.();
        instances.delete(root);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iem-esport"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-iem-esport]').forEach((sectionEl) => {
      const swiperEl = sectionEl.querySelector('.swiper');

      if (!swiperEl) {
        return;
      }

      const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;

      new Swiper(swiperEl, {
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: slideCount > 1,
        spaceBetween: 8,
        navigation: {
          nextEl: sectionEl.querySelector('[data-next]'),
          prevEl: sectionEl.querySelector('[data-prev]'),
        },
        breakpoints: {
          768: {
            spaceBetween: 16,
          },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iem-feature-slide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-iem-feature-slide]').forEach((sectionEl) => {
      const mediaItems = Array.from(sectionEl.querySelectorAll('[data-iem-feature-media]'));
      const contentItems = Array.from(sectionEl.querySelectorAll('[data-iem-feature-content]'));
      const prevButton = sectionEl.querySelector('[data-iem-feature-prev]');
      const nextButton = sectionEl.querySelector('[data-iem-feature-next]');
      let activeIndex = 0;
      if (!mediaItems.length || !contentItems.length) {
        return;
      }

      const syncVideos = () => {
        mediaItems.forEach((item, index) => {
          item.querySelectorAll('video').forEach((video) => {
            if (index === activeIndex) {
              video.currentTime = video.currentTime || 0;
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        });
      };

      const showSlide = (nextIndex) => {
        const normalizedIndex = (nextIndex + mediaItems.length) % mediaItems.length;

        if (normalizedIndex === activeIndex) {
          return;
        }

        activeIndex = normalizedIndex;

        mediaItems.forEach((item, index) => {
          item.classList.toggle('is-active', index === activeIndex);
        });

        contentItems.forEach((item, index) => {
          item.classList.toggle('is-active', index === activeIndex);
        });

        syncVideos();
      };

      if (prevButton) {
        prevButton.addEventListener('click', () => showSlide(activeIndex - 1));
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => showSlide(activeIndex + 1));
      }

      mediaItems.forEach((item, index) => {
        item.classList.toggle('is-active', index === activeIndex);
      });

      contentItems.forEach((item, index) => {
        item.classList.toggle('is-active', index === activeIndex);
      });

      syncVideos();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iem-nav"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const cssEscape = window.CSS && CSS.escape ? CSS.escape : (value) => value.replace(/[^a-zA-Z0-9_-]/g, '\\$&');

    const getTarget = (targetId) => {
      const cleanId = (targetId || '').trim().replace(/^#/, '');

      if (!cleanId) {
        return null;
      }

      return (
        document.getElementById(cleanId) ||
        document.getElementById(`shopify-section-${cleanId}`) ||
        document.querySelector(`[data-anchor-id="${cssEscape(cleanId)}"]`) ||
        document.querySelector(`[data-section-id="${cssEscape(cleanId)}"]`)
      );
    };

    document.querySelectorAll('[data-iem-nav]').forEach((sectionEl) => {
      const scrollerEl = sectionEl.querySelector('[data-iem-nav-scroller]');
      const navItems = Array.from(sectionEl.querySelectorAll('[data-iem-nav-link]')).map((linkEl) => ({
        linkEl,
        targetId: linkEl.getAttribute('data-target-id') || '',
        targetEl: null,
      }));
      let lockedItem = null;

      const refreshTargets = () => {
        navItems.forEach((item) => {
          item.targetEl = getTarget(item.targetId);
        });
      };

      const getOffset = () => {
        const sectionWrapper = sectionEl.closest('.shopify-section') || sectionEl.parentElement || sectionEl;
        const stickyTop = Number.parseFloat(window.getComputedStyle(sectionWrapper).top) || 0;

        return sectionEl.getBoundingClientRect().height + stickyTop;
      };

      const scrollActiveIntoView = (activeLink, behavior = 'smooth') => {
        if (!scrollerEl || !activeLink || scrollerEl.scrollWidth <= scrollerEl.clientWidth) {
          return;
        }

        const scrollerRect = scrollerEl.getBoundingClientRect();
        const activeRect = activeLink.getBoundingClientRect();
        const activeCenter = activeRect.left - scrollerRect.left + activeRect.width / 2;
        const scrollerCenter = scrollerEl.clientWidth / 2;
        const maxScrollLeft = scrollerEl.scrollWidth - scrollerEl.clientWidth;
        const nextScrollLeft = Math.max(
          0,
          Math.min(scrollerEl.scrollLeft + activeCenter - scrollerCenter, maxScrollLeft)
        );

        if (Math.abs(nextScrollLeft - scrollerEl.scrollLeft) < 1) {
          return;
        }

        scrollerEl.scrollTo({
          left: nextScrollLeft,
          behavior,
        });
      };

      const setActive = (activeLink, behavior = 'smooth') => {
        if (!activeLink) {
          return;
        }

        if (activeLink.classList.contains('is-active')) {
          scrollActiveIntoView(activeLink, behavior);
          return;
        }

        navItems.forEach((item) => {
          item.linkEl.classList.remove('is-active');
          item.linkEl.removeAttribute('aria-current');
        });

        activeLink.classList.add('is-active');
        activeLink.setAttribute('aria-current', 'true');
        scrollActiveIntoView(activeLink, behavior);
      };

      const clearLock = () => {
        lockedItem = null;
      };

      const updateActive = () => {
        if (lockedItem) {
          setActive(lockedItem.linkEl);
          return;
        }

        const offset = getOffset() + 1;
        let activeItem = null;
        let closestPastItem = null;
        let closestPastDistance = Infinity;
        let closestFutureItem = null;
        let closestFutureDistance = Infinity;

        navItems.forEach((item) => {
          if (!item.targetEl) {
            item.targetEl = getTarget(item.targetId);
          }

          if (!item.targetEl) {
            return;
          }

          const rect = item.targetEl.getBoundingClientRect();

          if (rect.top <= offset && rect.bottom > offset) {
            activeItem = item;
            return;
          }

          const distance = rect.top - offset;

          if (distance <= 0 && Math.abs(distance) < closestPastDistance) {
            closestPastDistance = Math.abs(distance);
            closestPastItem = item;
          }

          if (distance > 0 && distance < closestFutureDistance) {
            closestFutureDistance = distance;
            closestFutureItem = item;
          }
        });

        const nextActiveItem = activeItem || closestPastItem || closestFutureItem;

        if (nextActiveItem) {
          setActive(nextActiveItem.linkEl);
        }
      };

      let ticking = false;
      const requestUpdate = () => {
        if (ticking) {
          return;
        }

        ticking = true;
        window.requestAnimationFrame(() => {
          ticking = false;
          updateActive();
        });
      };

      navItems.forEach((item) => {
        item.linkEl.addEventListener('click', (event) => {
          refreshTargets();

          if (!item.targetEl) {
            event.preventDefault();
            return;
          }

          event.preventDefault();
          const top = Math.max(0, item.targetEl.getBoundingClientRect().top + window.scrollY - getOffset());

          setActive(item.linkEl);
          lockedItem = item;
          item.linkEl.blur();

          window.scrollTo({
            top,
            behavior: 'smooth',
          });
        });
      });

      window.addEventListener('wheel', clearLock, { passive: true });
      window.addEventListener(
        'touchstart',
        (event) => {
          if (!sectionEl.contains(event.target)) {
            clearLock();
          }
        },
        { passive: true }
      );
      window.addEventListener('keydown', (event) => {
        if (['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' '].includes(event.key)) {
          clearLock();
        }
      });

      refreshTargets();
      updateActive();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iem-top-rated"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-iem-top-rated]').forEach((sectionEl) => {
      const items = Array.from(sectionEl.querySelectorAll('[data-iem-top-rated-item]'));
      const mediaPanels = Array.from(sectionEl.querySelectorAll('[data-iem-top-rated-media]'));

      if (!items.length) {
        return;
      }

      const updatePanelHeights = () => {
        items.forEach((item) => {
          const panel = item.querySelector('[data-iem-top-rated-panel]');
          if (!panel) {
            return;
          }

          panel.style.maxHeight = item.classList.contains('is-active') ? `${panel.scrollHeight}px` : '0px';
        });
      };

      const setActive = (index) => {
        items.forEach((item, itemIndex) => {
          const isActive = itemIndex === index;
          const toggle = item.querySelector('[data-iem-top-rated-toggle]');

          item.classList.toggle('is-active', isActive);
          if (toggle) {
            toggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
          }
        });

        mediaPanels.forEach((panel, panelIndex) => {
          panel.classList.toggle('is-active', panelIndex === index);
        });

        requestAnimationFrame(updatePanelHeights);
      };

      items.forEach((item, index) => {
        const toggle = item.querySelector('[data-iem-top-rated-toggle]');
        if (!toggle) {
          return;
        }

        toggle.addEventListener('click', () => setActive(index));
      });

      setActive(0);
      window.addEventListener('resize', updatePanelHeights);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iem-user-say"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-iem-user-say]').forEach((sectionEl) => {
      const swiperEl = sectionEl.querySelector('.swiper');

      if (!swiperEl) {
        return;
      }

      new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        navigation: {
          nextEl: sectionEl.querySelector('[data-next]'),
          prevEl: sectionEl.querySelector('[data-prev]'),
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jingva-media-endorsement-new"] && !Shopify.designMode) return;
  try {
    
  const endorsementControllers = new WeakMap();

  function initEndorsements(scope) {
    const sections = scope.matches?.('.jingva-media-endorsement-new')
      ? [scope]
      : scope.querySelectorAll('.jingva-media-endorsement-new');

    for (const section of sections) {
      const slider = section.querySelector('[data-endorsement-slider]');
      if (!slider || endorsementControllers.has(section)) continue;

      const controller = new AbortController();
      const { signal } = controller;
      const previous = section.querySelector('[data-endorsement-prev]');
      const next = section.querySelector('[data-endorsement-next]');
      const navigation = section.querySelector('.jingva-endorsement-new-navigation');
      const title = section.querySelector('.jingva-endorsement-new-title');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');


      function updateNavigation(swiper) {
        if (!navigation) return;
        const allFit = swiper.isLocked || Math.abs(swiper.maxTranslate() - swiper.minTranslate()) <= 1;
        navigation.hidden = allFit;
        for (const [button, disabled] of [[previous, allFit || swiper.isBeginning], [next, allFit || swiper.isEnd]]) {
          button.disabled = disabled;
          button.setAttribute('aria-disabled', String(disabled));
          button.classList.toggle('swiper-button-disabled', disabled);
        }
      }

      const swiper = new Swiper(slider, {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        slidesPerGroupAuto: true,
        spaceBetween: 12,
        speed: reducedMotion.matches ? 0 : 300,
        loop: false,
        watchOverflow: true,
        preventInteractionOnTransition: true,
        centerInsufficientSlides: false,
        breakpoints: {
          1280: {
            centerInsufficientSlides: slider.querySelectorAll('.swiper-slide').length <= 3
          }
        },
        on: {
          init: updateNavigation,
          slideChange: updateNavigation,
          reachBeginning: updateNavigation,
          reachEnd: updateNavigation,
          fromEdge: updateNavigation,
          resize: updateNavigation,
          update: updateNavigation,
          lock: updateNavigation,
          unlock: updateNavigation
        }
      });

      previous?.addEventListener('click', () => {
        if (!swiper.animating && !previous.disabled) swiper.slidePrev();
      }, { signal });
      next?.addEventListener('click', () => {
        if (!swiper.animating && !next.disabled) swiper.slideNext();
      }, { signal });
      reducedMotion.addEventListener('change', () => {
        const speed = reducedMotion.matches ? 0 : 300;
        swiper.params.speed = speed;
        swiper.originalParams.speed = speed;
      }, { signal });
      section.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest('.swiper-slide');
        const index = Array.from(swiper.slides).indexOf(slide);
        if (index >= 0) swiper.slideTo(index, 0);
      }, { signal });

      endorsementControllers.set(section, () => {
        controller.abort();
        titleObserver?.disconnect();
        swiper.destroy(true, true);
        endorsementControllers.delete(section);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initEndorsements(document), { once: true });
  } else {
    initEndorsements(document);
  }

  document.addEventListener('shopify:section:load', (event) => initEndorsements(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const section of event.target.querySelectorAll('.jingva-media-endorsement-new')) {
      endorsementControllers.get(section)?.();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-g7-m6"]) return;
  try {
    
  (() => {
    if (document.documentElement.dataset.g7PaymentDialogBound === 'true') return;
    document.documentElement.dataset.g7PaymentDialogBound = 'true';

    const init = () => {
      const getDialog = (id) => document.getElementById(id);

      const openDialog = (dialog, trigger) => {
        if (!dialog) return;

        dialog._g7Trigger = trigger;
        dialog.hidden = false;
        dialog.setAttribute('aria-hidden', 'false');
        trigger?.setAttribute('aria-expanded', 'true');
        document.body.classList.add('g7-payment-dialog-open');

        requestAnimationFrame(() => {
          dialog.querySelector('[data-g7-payment-dialog-close]')?.focus();
        });
      };

      const closeDialog = (dialog) => {
        if (!dialog || dialog.hidden) return;

        dialog.hidden = true;
        dialog.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('g7-payment-dialog-open');
        dialog._g7Trigger?.setAttribute('aria-expanded', 'false');
        dialog._g7Trigger?.focus();
        dialog._g7Trigger = null;
      };

      // Keep PayPal's overlay above this regular-element modal. Its z-index is
      // 2147483647, while the modal is intentionally one level below it.
      const closePayPalParentDialog = (event) => {
        if (!(event.target instanceof Element)) return;

        const paypalMessage = event.target.closest('[data-pp-message]');
        const dialog = paypalMessage?.closest('[data-g7-payment-dialog]');
        if (dialog && !dialog.hidden) closeDialog(dialog);
      };

      document.addEventListener('pointerdown', closePayPalParentDialog, true);
      document.addEventListener('click', closePayPalParentDialog, true);
      document.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;

        const openButton = event.target.closest('[data-g7-payment-dialog-open]');
        if (openButton) {
          openDialog(getDialog(openButton.dataset.g7PaymentDialogOpen), openButton);
          return;
        }

        const closeButton = event.target.closest('[data-g7-payment-dialog-close]');
        if (closeButton) {
          closeDialog(closeButton.closest('[data-g7-payment-dialog]'));
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;

        document.querySelectorAll('[data-g7-payment-dialog]:not([hidden])').forEach(closeDialog);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    const messages = document.querySelectorAll('[data-pp-message]');
    const media = window.matchMedia('(max-width: 767px)');

    function updatePayPalMessage() {
      messages.forEach((message) => {
        message.setAttribute('data-pp-style-text-size', media.matches ? '12' : '14');
      });
    }

    updatePayPalMessage();
    media.addEventListener('change', updatePayPalMessage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["payment-find"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-payment-find]').forEach((sectionEl) => {
      const swiperEl = sectionEl.querySelector('.swiper');

      if (!swiperEl || swiperEl.swiper) {
        return;
      }

      const syncSlideAccessibility = (swiper) => {
        for (const slideEl of swiper.slides) {
          const isVisible = slideEl.classList.contains('swiper-slide-visible');
          slideEl.setAttribute('aria-hidden', isVisible ? 'false' : 'true');

          for (const linkEl of slideEl.querySelectorAll('a')) {
            if (isVisible) {
              linkEl.removeAttribute('tabindex');
            } else {
              linkEl.setAttribute('tabindex', '-1');
            }
          }
        }
      };

      new Swiper(swiperEl, {
        slidesPerView: 'auto',
        watchSlidesProgress: true,
        navigation: {
          nextEl: sectionEl.querySelector('[data-next]'),
          prevEl: sectionEl.querySelector('[data-prev]'),
        },
        on: {
          init: syncSlideAccessibility,
          resize: syncSlideAccessibility,
          slideChange: syncSlideAccessibility,
          transitionEnd: syncSlideAccessibility,
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-countdown-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const definePromoBar = () => {
      if (customElements.get('promo-countdown-bar')) return;

      class PromoCountdownBar extends HTMLElement {
        connectedCallback() {
          this.section = this.closest('.promo-countdown-bar');
          this.numbers = Array.from(this.querySelectorAll('[data-promo-unit]'));
          this.closeButton = this.querySelector('[data-promo-close]');
          this.abortController = new AbortController();
          const { signal } = this.abortController;
          this.closeButton?.removeAttribute('disabled');
          this.closeButton?.addEventListener('click', () => this.dismiss(), { signal });

          const value = (this.dataset.endTime || '').trim();
          this.endTimestamp = Number.NaN;
          if (/^\d{10}$/.test(value)) {
            this.endTimestamp = Number(value) * 1000;
          } else if (/^\d{13}$/.test(value)) {
            this.endTimestamp = Number(value);
          } else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?(?:Z|[+-]\d{2}:\d{2})$/i.test(value)) {
            this.endTimestamp = Date.parse(value);
          }

          if (this.dataset.designMode === 'true') {
            document.addEventListener('shopify:section:select', (event) => {
              if (event.detail.sectionId !== this.section.id) return;
              this.section.hidden = false;
              this.start();
            }, { signal });
          }

          document.addEventListener('visibilitychange', () => {
            if (document.hidden) this.stop();
            else if (!this.section.hidden) this.start();
          }, { signal });
          this.start();
        }

        start() {
          this.stop();
          if (!Number.isFinite(this.endTimestamp) || this.numbers.length === 0) return;
          if (this.update() && !document.hidden) {
            this.interval = window.setInterval(() => this.update(), 1000);
          }
        }

        update() {
          // Always subtract absolute timestamps; never decrement a stored counter.
          const remaining = Math.max(0, Math.ceil((this.endTimestamp - Date.now()) / 1000));
          const values = {
            days: Math.floor(remaining / 86400),
            hours: Math.floor((remaining % 86400) / 3600),
            minutes: Math.floor((remaining % 3600) / 60),
            seconds: remaining % 60,
          };
          this.numbers.forEach((number) => {
            const text = String(values[number.dataset.promoUnit]).padStart(2, '0');
            if (number.textContent !== text) number.textContent = text;
          });
          if (remaining === 0) {
            this.stop();
            if (this.dataset.hideOnExpiry === 'true' && this.dataset.designMode !== 'true') {
              this.section.hidden = true;
            }
          }
          return remaining > 0;
        }

        stop() {
          window.clearInterval(this.interval);
          this.interval = null;
        }

        dismiss() {
          this.stop();
          this.section.hidden = true;
        }

        disconnectedCallback() {
          this.stop();
          this.abortController?.abort();
        }
      }

      customElements.define('promo-countdown-bar', PromoCountdownBar);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', definePromoBar, { once: true });
    } else {
      definePromoBar();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
